<template>
  <div>
    <v-snackbar v-model="snackbar.status" :color="snackbar.color" :timeout="snackbar.timeout" dark>
      <span class="font-weight-bold">{{ snackbar.text }}</span>
      <template v-slot:action="{ attrs }">
        <v-btn
            class="font-weight-bold"
            color="white"
            text
            v-bind="attrs"
            @click="snackbar.status = false"
        >Fechar
        </v-btn>
      </template>
    </v-snackbar>
    <v-dialog v-model="dialogErro.status" persistent max-width="500">
      <CardDialog :dialog="dialogErro"/>
    </v-dialog>
    <v-dialog v-model="dialogProfissionais" fullscreen style="overflow-y: auto;">
      <v-overlay opacity="0.8" class="overlay-fullwidth">
        <v-row class="pa-5">
          <v-col cols="12" md="12">
            <v-card color="primary" dark
                    :style="$vuetify.breakpoint.smAndDown ? 'display: flex; flex-direction: column; max-height: 50vh;' : 'display: flex; flex-direction: column; max-height: 90vh;'">
              <v-card-title>Lista de Terceiros relacionados ao cliente - {{ clienteNome }}
                <v-spacer/>
                <v-btn color="white" icon @click="closeDialogProfissional">
                  <v-icon> mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-divider/>
              <v-card-text style="flex: 1; overflow-y: auto;" class="scroll-detalhes pb-0">
                <template v-if="qtdProfissionalCliente > 0">
                  <v-container fluid>
                    <v-data-iterator
                        :items="itemsTeste"
                        :items-per-page.sync="itemsPerPage"
                        :sort-by="sortBy.toLowerCase()"
                        :sort-desc="sortDesc"
                        :page.sync="page"
                        :search="search"
                        hide-default-footer
                    >
                      <template v-slot:header>
                        <v-toolbar dark color="red darken-3" class="mb-1">
                          <v-text-field
                              v-model="search"
                              clearable
                              flat
                              solo-inverted
                              hide-details
                              prepend-inner-icon="mdi-magnify"
                              label="Buscar"
                          ></v-text-field>
                          <template v-if="$vuetify.breakpoint.mdAndUp">
                            <v-spacer></v-spacer>
                            <v-btn-toggle v-model="sortDesc" mandatory>
                              <v-btn large depressed color="white" :value="false">
                                <v-icon color="red darken-3">mdi-arrow-up</v-icon>
                              </v-btn>
                              <v-btn large depressed color="white" :value="true">
                                <v-icon color="red darken-3">mdi-arrow-down</v-icon>
                              </v-btn>
                            </v-btn-toggle>
                          </template>
                        </v-toolbar>
                      </template>

                      <template v-slot:default="props">
                        <v-row>
                          <v-col
                              v-for="item in props.items"
                              :key="item.nome"
                              cols="12"
                              sm="6"
                              md="4"
                              lg="3"
                          >
                            <v-card class="v-card-profissional">
                              <v-card-title class="subheading font-weight-bold">
                                {{ item.nome }}
                              </v-card-title>

                              <v-divider></v-divider>

                              <v-list dense class="v-card-profissional">
                                <v-list-item>
                                  <v-list-item-content>
                                    <strong>Profissão:</strong> {{ item.tipoProfissional }}
                                  </v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                  <v-list-item-content>
                                    <strong>Validade:</strong> {{ item.dataValidade }}
                                  </v-list-item-content>
                                </v-list-item>
                              </v-list>

                              <v-divider></v-divider>

                              <!-- Barra de Progresso -->
                              <v-card-text>
                                <div class="align-center justify-center">
                                  <span style="font-size: 12px; text-align: center">Validade de permissão do Terceiro</span>
                                </div>
                                <v-progress-linear
                                    :value="calcularProgresso(item.dataValidade)"
                                    :color="definirCor(item.dataValidade)"
                                    height="15"
                                    rounded
                                >
                                  {{ calcularDiasRestantes(item.dataValidade) }} dias restantes
                                </v-progress-linear>
                              </v-card-text>
                            </v-card>
                          </v-col>
                        </v-row>
                      </template>

                      <template v-slot:footer>
                        <v-row class="mt-2 pl-3 pr-3" align="center" justify="center">
                          <span class="grey--text">Itens por página</span>
                          <v-menu offset-y>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn dark text class="ml-2" v-bind="attrs" v-on="on">
                                {{ itemsPerPage }}
                                <v-icon>mdi-chevron-down</v-icon>
                              </v-btn>
                            </template>
                            <v-list>
                              <v-list-item
                                  v-for="(number, index) in itemsPerPageArray"
                                  :key="index"
                                  @click="updateItemsPerPage(number)"
                              >
                                <v-list-item-title>{{ number }}</v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu>

                          <v-spacer></v-spacer>

                          <span class="mr-4 grey--text">Página {{ page }} de {{ numberOfPages }}</span>
                          <v-btn fab dark color="red darken-3" class="mr-1" @click="formerPage">
                            <v-icon>mdi-chevron-left</v-icon>
                          </v-btn>
                          <v-btn fab dark color="red darken-3" class="ml-1" @click="nextPage">
                            <v-icon>mdi-chevron-right</v-icon>
                          </v-btn>
                        </v-row>
                      </template>
                    </v-data-iterator>
                  </v-container>


                </template>
                <template v-else>Nenhum terceiro relacionado ao cliente.</template>
              </v-card-text>
              <v-card-actions><span></span></v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-overlay>
    </v-dialog>

    <v-dialog v-model="dialogDocumentoAssinado">
      <v-overlay opacity="0.8" class="overlay-fullwidth">
        <v-row class="pa-5">
          <v-col cols="12" md="12">
            <v-card color="primary" dark
                    :style="$vuetify.breakpoint.smAndDown ? 'display: flex; flex-direction: column; max-height: 90vh;' : 'display: flex; flex-direction: column; max-height: 90vh;'">
              <v-card-title v-if="tipoDoc === 'P' ">Contrato de Permissão de Retirada de Produtos - {{ clienteDoc }}
                <v-spacer/>
                <v-btn color="white" icon @click="dialogDocumentoAssinado = false">
                  <v-icon> mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-divider/>
              <v-card-text style="flex: 1; overflow-y: auto;" class="scroll-detalhes pb-0">
                <div class="pa-1 white rounded" v-if="pdfSrc !== null">
                  <vue-pdf-embed v-if="pdfSrc" :source="pdfSrc" />
                  <p v-else>Carregando PDF...</p>
                </div>
                <div class="pa-1 white rounded" v-if="imagens.length > 0">
                  <v-carousel height="100%">
                    <v-carousel-item
                        v-for="(imagem,i) in imagens"
                        :key="i"
                        :src="imagem"
                        reverse-transition="fade-transition"
                        transition="fade-transition"
                    >
                    </v-carousel-item>
                  </v-carousel>
                </div>
                <template v-else>Nenhum documento encontrado</template>
              </v-card-text>
              <v-card-actions><span></span></v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-overlay>
    </v-dialog>

    <v-dialog v-model="dialogGerarPermissao" max-width="500" max-height="700" scrollable persistent>
      <v-card class="pa-0" elevation="0">
        <v-card-title>
          <span class="text-h6 text--primary">Cadastro de permissão</span>
          <v-spacer/>
          <v-btn color="primary" icon @click="closeDialogPermissao()">
            <v-icon> mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider/>
        <v-card-text class="pa-0">
          <v-stepper v-model="e1" vertical :key="dadosGerarPermissao.dadosCliente.idclifor">
            <v-stepper-step
                :complete="e1 > 1"
                step="1"
            >
              Selecionar Cliente
            </v-stepper-step>

            <v-stepper-content step="1" >
              <v-card
                  class="pa-0 mb-10"
                  elevation="0"
              >
                <v-card-text class="pa-0 pt-1">
                  <div class="mb-n4">
                    <v-autocomplete
                        class="pa-0"
                        no-filter
                        v-model="dadosGerarPermissao.dadosCliente.idclifor"
                        outlined
                        dense
                        label="Cliente"
                        :search-input.sync="searchCliente"
                        :items="itemsClientes"
                        :loading="carregando2"
                        item-text="idenome"
                        item-value="idcliente"
                    ></v-autocomplete>
                  </div>
                  <fieldset class="px-4 pb-3" v-if="dadosGerarPermissao.dadosCliente.idclifor != null">
                      <legend>Dados do cliente</legend>
                      <v-row class="py-2">
                        <v-col cols="12" class="py-0">
                          <strong>Nome:</strong> {{ dadosGerarPermissao.dadosCliente.idclifor }} -
                          {{ dadosGerarPermissao.dadosCliente.nome }} <br/>
                          <strong>CPF/CNPJ:</strong> {{ formataCPF(dadosGerarPermissao.dadosCliente.cpf) }} <br/>
                          <strong>Endereço:</strong> {{ dadosGerarPermissao.dadosCliente.endereco }}, N°
                          {{ dadosGerarPermissao.dadosCliente.numero }} - {{
                            dadosGerarPermissao.dadosCliente.bairro
                          }}<br/>
                          <strong>Cidade:</strong> {{ dadosGerarPermissao.dadosCliente.cidade }} -
                          {{ dadosGerarPermissao.dadosCliente.uf }}
                        </v-col>
                      </v-row>
                    </fieldset>
                  <v-row class="mb-n10">
                    <v-col cols="12" class="py-6 pb-4 mb-n8">
                      <v-text-field v-model="dadosGerarPermissao.dadosCliente.telefone" type="text" required
                                    :rules="validarTelefone"
                                    outlined
                                    dense label="Telefone"
                                    maxlength="15"></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-btn
                          color="primary"
                          block
                          @click="e1 = 2"
                          :disabled="!validaClientePermissao"
                      >
                        Continue
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

            </v-stepper-content>

            <v-stepper-step
                :complete="e1 > 2"
                step="2"
                class="pb-0"
            >
              Selecionar Autorizado
            </v-stepper-step>

            <v-stepper-content step="2">
              <v-card
                  class="pa-0"
                  elevation="0"
              >
                <v-radio-group hide-details v-model="novoAutorizado" class="ma-0 pb-md-2" row>
                  <v-col cols="8" class="pa-0" style="display: flex; gap: 16px;">
                    <v-col cols="auto" class="pa-0">
                      <v-radio color="red darken-3" label="Autorizado CISS" value="F"/>
                    </v-col>
                    <v-col cols="auto" class="pa-0">
                      <v-radio color="red darken-3" label="Novo Autorizado" value="T"/>
                    </v-col>
                  </v-col>

                </v-radio-group>
                <v-card-text class="pa-0">
                  <div class="mb-n2" v-if="novoAutorizado === 'F'">
                    <v-autocomplete
                        class="pa-0"
                        no-filter
                        v-model="dadosGerarPermissao.dadosTerceiro.idclifor"
                        outlined
                        dense
                        label="Autorizado"
                        :search-input.sync="searchTerceiro"
                        :items="itemsTerceiros"
                        :loading="carregando3"
                        item-text="idenome"
                        item-value="idcliente"
                        :rules="validaTerceiroRules"
                    ></v-autocomplete>
                  </div>

                  <fieldset class="px-4 pb-3"
                            v-if="dadosGerarPermissao.dadosTerceiro.nome !== null || novoAutorizado === 'T'">
                    <legend>Dados do Autorizado</legend>
                    <div v-if="novoAutorizado === 'T'">
                      <div class="pb-1 py-2">
                        <v-icon class="mr-2">mdi-account</v-icon>
                        <span class="font-weight-bold">Nome</span>
                      </div>
                      <v-text-field v-model="dadosGerarPermissao.dadosTerceiro.nome" type="text" required
                                    outlined dense maxlength="100"></v-text-field>
                    </div>

                    <div>
                      <div class="pb-1">
                        <v-icon class="mr-2">mdi-card-account-details-outline</v-icon>
                        <span class="font-weight-bold">CPF</span>
                      </div>
                      <v-text-field v-model="dadosGerarPermissao.dadosTerceiro.cpf" type="text" required
                                    outlined
                                    dense v-mask="'###.###.###-##'"
                                    maxlength="14"></v-text-field>
                    </div>
                    <div class="pt-2">
                      <v-text-field v-model="dadosGerarPermissao.dadosTerceiro.telefone" type="text" required
                                    outlined
                                    dense label="Telefone"
                                    maxlength="15"></v-text-field>
                    </div>

                    <div>
                      <div class="pb-1 py-2">
                        <v-icon class="mr-2">mdi-account</v-icon>
                        <span class="font-weight-bold">É um profissional da obra?</span>
                      </div>
                      <v-radio-group hide-details v-model="verificaAutorizado" class="ma-0 pb-md-2" row>
                        <v-col cols="8" class="pa-0" style="display: flex; gap: 16px;">
                          <v-col cols="auto" class="pa-0">
                            <v-radio color="red darken-3" label="Não" value="N"/>
                          </v-col>
                          <v-col cols="auto" class="pa-0">
                            <v-radio color="red darken-3" label="Sim" value="S"/>
                          </v-col>
                        </v-col>

                      </v-radio-group>
                    </div>

                    <div class="py-2" v-if="verificaAutorizado === 'S'">
                      <div class="pb-1">
                        <v-icon class="mr-2">mdi-account-hard-hat</v-icon>
                        <span class="font-weight-bold">Tipo Profissional</span>
                      </div>
                      <v-select class="pa-0" v-model="dadosGerarPermissao.dadosTerceiro.tipoProfissional"
                                :items="tipoProfissional" required
                                outlined dense
                                item-text="PROFISSIONAL" item-value="ID"></v-select>
                    </div>

                    <div class="py-2" v-if="verificaAutorizado === 'N'">
                      <div class="pb-1">
                        <v-icon class="mr-2">mdi-account-supervisor</v-icon>
                        <span class="font-weight-bold">Tipo de Relacionamento</span>
                      </div>
                      <v-select class="pa-0" v-model="dadosGerarPermissao.dadosTerceiro.tipoRelacionamento"
                                :items="tipoRelacionamento" required
                                outlined dense
                                item-text="relacionamento" item-value="id"></v-select>
                    </div>

                    <div>
                      <div class="pb-1">
                        <v-icon class="mr-2">mdi-calendar</v-icon>
                        <span class="font-weight-bold">Data Validade Permissão</span>
                      </div>
                      <InputDatePicker :disabled="carregando" v-model="dadosGerarPermissao.dadosTerceiro.dataValidade"
                                       :rules="validarData"
                                       :outlined="true" :dense="true" :hide-details="false"
                      />
                    </div>
                  </fieldset>


                </v-card-text>
              </v-card>

              <v-col cols="12" class="pa-0 pt-2">
                <div>
                  <v-btn
                      color="primary"
                      text
                      @click="e1 = 1"
                      block
                      outlined
                  >
                    Voltar
                  </v-btn>
                </div>

                <div class="pt-2">
                  <v-btn
                      color="primary"
                      @click="gerarLinkPermissao()"
                      block
                      :disabled="!validaDadosTotalPermissao"
                  >
                    Gerar Links
                  </v-btn>
                </div>

              </v-col>
            </v-stepper-content>

            <v-stepper-step
                :complete="e1 > 3"
                step="3"
            >
              Gerar links
            </v-stepper-step>

            <v-stepper-content step="3" class="ma-0 pa-2 pb-0">
              <v-card elevation="0" class="pa-0">
                <v-card-subtitle class="px-6 py-0">
                  <div class="red--text text-caption">
                    <p class="ma-0 mb-1"><b>Avisos Importantes:</b></p>
                    <p class="ma-0">1. Não compartilhe o link com ninguém além do assinante autorizado.</p>
                    <p class="ma-0">2. Certifique-se de copiar e compartilhar todos links necessários.</p>
<!--                    <p class="ma-0"><strong>3. </strong> Ao gerar um contrato físico, o contrato digital será automaticamente cancelado, e todo o progresso associado a ele será perdido.</p>-->
                  </div>
                </v-card-subtitle>
                <v-card-text class="pa-2 pt-4"
                             v-if="dadosGerarPermissao.dadosCliente && dadosGerarPermissao.dadosTerceiro && linksPermissao.linkCliente && linksPermissao.linkProfissional">
<!--                  <div>-->
<!--                    <v-btn-->
<!--                        color="primary"-->
<!--                        block-->
<!--                        @click="gerarContratoFisico"-->
<!--                    >-->
<!--                      Gerar contrato físico-->
<!--                    </v-btn>-->
<!--                  </div>-->

                  <div class="pt-4">
                    <v-text-field
                        :label="'Link Cliente: ' + (dadosGerarPermissao.dadosCliente.nome)"
                        ref="copiar"
                        dense
                        :value="linksPermissao.linkCliente"
                        outlined
                        color="primary"
                        hide-details
                        readonly
                    >
                      <template v-slot:append>
                        <v-btn small color="primary" icon :loading="carregando"
                               @click="copy(linksPermissao.linkCliente, 'copiar')">
                          <v-icon size="18">mdi-content-copy</v-icon>
                        </v-btn>
                        <v-btn class="mr-n1" small color="primary" icon :loading="carregando"
                               @click="gerarQRCode(linksPermissao.linkCliente,'Cliente:\n' + (dadosGerarPermissao.dadosCliente.nome))">
                          <v-icon size="18">mdi-qrcode-scan</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>
                  </div>
                  <div class="pt-4">
                    <v-text-field
                        :label="'Link Autorizado: ' + (dadosGerarPermissao.dadosTerceiro.nome)"
                        ref="copiar"
                        dense
                        :value="linksPermissao.linkProfissional"
                        outlined
                        color="primary"
                        hide-details
                        readonly
                    >
                      <template v-slot:append>
                        <v-btn small color="primary" icon :loading="carregando"
                               @click="copy(linksPermissao.linkProfissional, 'copiar')">
                          <v-icon size="18">mdi-content-copy</v-icon>
                        </v-btn>
                        <v-btn class="mr-n1" small color="primary" icon :loading="carregando"
                               @click="gerarQRCode(linksPermissao.linkProfissional,'Autorizado:\n' + (dadosGerarPermissao.dadosTerceiro.nome))">
                          <v-icon size="18">mdi-qrcode-scan</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>
                  </div>

                </v-card-text>
              </v-card>
            </v-stepper-content>


          </v-stepper>
        </v-card-text>

      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogGerarRecibo" max-width="700" scrollable persistent>
      <v-card elevation="0">
        <v-card-title class="primary white--text pt-4 pr-3">
          <v-row no-gutters>
            <v-col cols="12">
              <div class="d-flex">
                <span>Recibo de Venda (Online) </span>
                <v-spacer/>
                <v-btn color="white" icon @click="closeDialogGerarRecibo()" class="mt-n2 mr-n1">
                  <v-icon> mdi-close</v-icon>
                </v-btn>
              </div>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-bold text-subtitle-2 mb-0">Cliente: {{ dadosGerarRecibo.nomeClienteRecibo }}
                (Documento: {{ dadosGerarRecibo.pedidoRecibo }})</p>
            </v-col>
          </v-row>
        </v-card-title>
        <v-divider/>
        <v-stepper v-model="step" vertical elevation="0">
          <v-stepper-step
              :complete="step > 1"
              step="1"
              class="font-weight-medium py-3"
          >
            Selecionar Terceiro
          </v-stepper-step>
          <v-stepper-content step="1" class="py-2 font-weight-black">
            <v-card outlined>
              <v-card-text class="px-4 pb-5 pt-1">
                <div>
                  <v-select v-model="dadosGerarRecibo.terceiroSelecionado" :items="terceirosAssinar" required outlined
                            dense
                            label="Terceiro autorizado para retirada" item-text="nome" item-value="idclifor"
                            class="pt-3 mb-0"></v-select>
                </div>
                <div class="py-2">
                  <fieldset class="px-4 pb-3" v-if="dadosGerarRecibo.terceiroSelecionado != null">
                    <legend>Dados do cliente</legend>
                    <v-row class="py-2">
                      <v-col cols="12" class="py-0">
                        <strong>Nome:</strong> {{ dadosGerarRecibo.dadosTerceiro.nome }}<br/>
                        <strong>CPF:</strong> {{ formataCPF(dadosGerarRecibo.dadosTerceiro.cpf) }} <br/>
                        <strong>Profissional:</strong> {{ dadosGerarRecibo.dadosTerceiro.tipoProfissional }}
                      </v-col>

                    </v-row>
                  </fieldset>
                </div>

                <div>
                  <v-btn :disabled="!validaTerceiro" class="primary py-2" width="100%"
                         @click="gerarLinkRecibo()" elevation="0">
                    <v-icon class="mr-2">
                      mdi-play
                    </v-icon>
                    Gerar link de assinatura
                  </v-btn>
                </div>

              </v-card-text>
            </v-card>
          </v-stepper-content>

          <v-stepper-step
              :complete="step > 2"
              step="2"
              class="font-weight-medium"
          >
            Envio de links para Assinatura
          </v-stepper-step>

          <v-stepper-content step="2" class="ma-0 pt-0 pb-0 pa-8">

            <v-card elevation="0" class="pa-0">
              <v-card-subtitle class="px-6 py-0">
                <div class="red--text text-caption">
                  <strong>Aviso Importante:</strong> *Não compartilhe o link com ninguém além do assinante autorizado.
                </div>
              </v-card-subtitle>
              <v-card-text class="pa-0">
                <v-row no-gutters>
                  <v-col cols="12" v-if="retornoDocOnline.retorno">
                    <v-text-field
                        :label="'Link Assinante: ' + dadosGerarRecibo.dadosTerceiro.nome"
                        ref="copiar1"
                        dense
                        v-model="retornoDocOnline.linkRecibo"
                        outlined
                        color="primary"
                        class="mb-5 mt-2"
                        hide-details
                        readonly
                        :disabled="retornoDocOnline.statusAssinatura === 'A'"
                    >
                      <template v-slot:append>
                        <v-tooltip color="success" left v-if="retornoDocOnline.statusAssinatura === 'A'">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                                size="30"
                                class="mr-1"
                                color="success"
                                v-bind="attrs"
                                v-on="on"
                            >
                              mdi-checkbox-marked-circle
                            </v-icon>
                          </template>
                          <span>Link já assinado</span>
                        </v-tooltip>
                        <template v-else>
                          <v-btn class="mt-n1" color="primary" icon :loading="carregando"
                                 @click="copy(retornoDocOnline.linkRecibo, 'copiar1')">
                            <v-icon size="20">mdi-content-copy</v-icon>
                          </v-btn>
                          <v-btn class="mt-n1" color="primary" icon :loading="carregando"
                                 @click="gerarQRCode(retornoDocOnline.linkRecibo,'Assinante:\n' + dadosGerarRecibo.dadosTerceiro.nome)">
                            <v-icon size="20">mdi-qrcode-scan</v-icon>
                          </v-btn>
                        </template>
                      </template>
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

          </v-stepper-content>


        </v-stepper>

      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDocPendente" persistent max-width="580">
      <v-card>
        <v-card-title class="primary white--text">
          <span>Dados do Contrato</span>
          <v-spacer/>
          <v-btn color="white" icon @click="abrirDialogPendente('Fechar'); listarAutorizacoes()" class="mt-n1 mr-n3">
            <v-icon> mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider/>
        <v-card-text class="pb-1">
          <v-col cols="12" class="px-0">
            <strong>Cliente:</strong> {{ dadosPendente.cliente }} <br/>
            <strong>Autorizado:</strong> {{ dadosPendente.autorizado }} <br/>
            <strong>Data de Cadastro:</strong> {{ dadosPendente.dtcadastro }} <br/>
            <strong>Data de Validade:</strong> {{ dadosPendente.dtvalidade }} <br/>
          </v-col>
        </v-card-text>
        <v-col cols="12" class="pt-0" v-if="dadosPendente.statusGeral === 'P' && dadosPendente.tipoContrato === 'D'">
          <div class="red--text text-caption pb-2">
            <p class="ma-0 mb-1"><b>Avisos Importantes:</b></p>
            <p class="ma-0">1. Não compartilhe o link com ninguém além do assinante autorizado.</p>
            <p class="ma-0">2. Certifique-se de copiar e compartilhar todos links necessários.</p>
            <p class="ma-0"><strong>3. </strong> Ao gerar um contrato físico, o contrato digital será automaticamente cancelado, e todo o progresso associado a ele será perdido.</p>
          </div>
          <div class="pb-3" >
            <v-btn
                @click="alteraContrato"
                color="primary"
                block
            >
              Gerar contrato físico
            </v-btn>
          </div>
          <v-text-field
              :label="'Link Cliente: ' + dadosPendente.cliente"
              ref="copiar1"
              dense
              v-model="dadosPendente.hashCliente"
              outlined
              color="primary"
              class="mb-5 mt-2"
              hide-details
              readonly
              :disabled="dadosPendente.statusAssinaturaCliente === 'A'"
          >
            <template v-slot:append>
              <v-tooltip color="success" left v-if="dadosPendente.statusAssinaturaCliente === 'A'">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                      size="30"
                      class="mr-1"
                      color="success"
                      v-bind="attrs"
                      v-on="on"
                  >
                    mdi-checkbox-marked-circle
                  </v-icon>
                </template>
                <span>Link já assinado</span>
              </v-tooltip>
              <template v-else>
                <v-btn class="mt-n1" color="primary" icon :loading="carregando"
                       @click="copy(dadosPendente.hashCliente, 'copiar1')">
                  <v-icon size="20">mdi-content-copy</v-icon>
                </v-btn>
                <v-btn class="mt-n1" color="primary" icon :loading="carregando"
                       @click="gerarQRCode(dadosPendente.hashCliente,'Cliente:\n' + dadosPendente.cliente)">
                  <v-icon size="20">mdi-qrcode-scan</v-icon>
                </v-btn>
              </template>
            </template>
          </v-text-field>

          <v-text-field
              :label="'Link Autorizado: ' + (dadosPendente.autorizado)"
              ref="copiar2"
              dense
              v-model="dadosPendente.hashProfissional"
              outlined
              color="primary"
              class="mb-5"
              hide-details
              readonly
              :disabled="dadosPendente.statusAssinaturaProfissional === 'A'"
          >
            <template v-slot:append>
              <v-tooltip color="success" left v-if="dadosPendente.statusAssinaturaProfissional === 'A'">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                      size="30"
                      class="mr-1"
                      color="success"
                      v-bind="attrs"
                      v-on="on"
                  >
                    mdi-checkbox-marked-circle
                  </v-icon>
                </template>
                <span>Link já assinado</span>
              </v-tooltip>
              <template v-else>
                <v-btn class="mt-n1" color="primary" icon :loading="carregando"
                       @click="copy(dadosPendente.hashProfissional, 'copiar2')">
                  <v-icon size="20">mdi-content-copy</v-icon>
                </v-btn>
                <v-btn class="mt-n1" color="primary" icon :loading="carregando"
                       @click="gerarQRCode(dadosPendente.hashProfissional,'Autorizado:\n' + dadosPendente.autorizado)">
                  <v-icon size="22">mdi-qrcode-scan</v-icon>
                </v-btn>
              </template>
            </template>
          </v-text-field>

        </v-col>
        <v-col cols="12" v-else-if="dadosPendente.statusGeral === 'P'">

          <div class="pb-3" >
            <v-btn
                @click="alteraContrato"
                color="primary"
                block
            >
              Gerar contrato para impressão
            </v-btn>
          </div>
        </v-col>
        <v-divider/>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogTermoFisico" persistent max-width="580">
      <v-card>
        <v-card-title class="primary white--text">
          <span>Dados do Contrato</span>
          <v-spacer/>
          <v-btn color="white" icon @click="uploadContrato('Fechar'); listarAutorizacoes()" class="mt-n1 mr-n3">
            <v-icon> mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-5 pb-0">
          <v-col cols="12" class="px-0">
            <strong>Cliente:</strong> {{ dadosPendente.cliente }} <br/>
            <strong>Autorizado:</strong> {{ dadosPendente.autorizado }} <br/>
            <strong>Data de Cadastro:</strong> {{ dadosPendente.dtcadastro }} <br/>
            <strong>Data de Validade:</strong> {{ dadosPendente.dtvalidade }} <br/>
          </v-col>
          <v-col cols="12" class="px-0">
            <v-file-input
                v-model="arquivoSelecionado"
                show-size
                clearable
                counter
                :loading="carregando"
                label="Anexar imagem do contrato"
                accept="image/png, image/jpeg, image/jpg"
                @change="adicionarArquivo"
            ></v-file-input>
            <p class="mt-4 mb-0">* Tamanho máximo de 5mb por arquivo.</p>
            <p
                class="mb-0 red--text"
            >** Antes de enviar o arquivo, confira se a imagem esta legível e se todos os campos foram preenchidos corretamente.</p>
          </v-col>
        </v-card-text>
        <v-divider class="primary" />
        <v-card-actions class="pa-3">
          <v-btn
              :loading="carregando"
              color="primary"
              elevation="0"
              @click="enviarContrato()"
              block
              :disabled="this.arquivos.length===0"
          >Enviar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogRenovaTermo" persistent max-width="580">
      <v-card>
        <v-card-title class="primary white--text">
          <span>Dados Termo para Renovação</span>
          <v-spacer/>
          <v-btn color="white" icon @click="renovarTermo('Fechar'); listarAutorizacoes()" class="mt-n1 mr-n3">
            <v-icon> mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider/>
        <v-card-text class="pb-1">
          <v-col cols="12" class="px-0">
            <strong>Cliente:</strong> {{ dadosPendente.cliente }} <br/>
            <strong>Autorizado:</strong> {{ dadosPendente.autorizado }} <br/>
            <strong>Data de Cadastro:</strong> {{ dadosPendente.dtcadastro }} <br/>
            <strong>Data de Validade Vigente:</strong> {{ dadosPendente.dtvalidade }} <br/>
          </v-col>
        </v-card-text>
        <v-col cols="12" class="pb-0 pt-0">
          <v-textarea
              name="obs"
              filled
              label="Motivo da renovação"
              v-model="obsRenovacao"
          ></v-textarea>
        </v-col>
        <v-col cols="12" class="pb-0">
          <div>
            <div class="pb-1">
              <v-icon class="mr-2">mdi-calendar</v-icon>
              <span class="font-weight-bold">Nova Data de Validade Permissão</span>
            </div>
            <InputDatePicker :disabled="carregando" v-model="dtvalidadeRenovacao"
                             :rules="validarData"
                             :outlined="true" :dense="true" :hide-details="false"
            />
          </div>
        </v-col>
        <v-divider/>
        <v-card-actions>
          <v-btn
              color="success"
              block
              :disabled="carregando2"
              @click="atualizarValidade"
          >
            Atualizar Data de Validade
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDeletar" max-width="580" scrollable persistent>
      <v-card>
        <v-card-title class="primary white--text">
          <span class="mx-auto">Exclusão de Permissão</span>
        </v-card-title>
        <div class="text-center py-3">
          <v-icon size="100" color="red">mdi-help-circle-outline</v-icon>
        </div>
        <v-card-subtitle class="text-center">
          <strong>Deseja realmente excluir a permissão de retirada de {{ dadosDeletar.profissionalDoc }}? </strong>
          <br/>
        </v-card-subtitle>
        <v-card-text v-if="dadosDeletar.idDoc">
          <v-row>
            <v-col cols="12">
              <strong>Filial: {{ dadosDeletar.filial }}</strong> <br/>
              <strong>Cliente: {{ dadosDeletar.clienteDoc }}</strong> <br/>
              <strong>Autorizado: {{ dadosDeletar.profissionalDoc }}</strong> <br/>
              <strong>Data de Cadastro: {{ dadosDeletar.dtcadastro }}</strong> <br/>
              <strong>Data de Validade: {{ dadosDeletar.dtvalidade }}</strong> <br/>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn
              :loading="carregando"
              text
              color="primary"
              elevation="0"
              outlined
              @click="dialogDeletar = false; listarAutorizacoes(); limparOperacao('D')"
              width="49%"
          >Cancelar
          </v-btn>
          <v-btn :loading="carregando" class="white--text" color="red darken-3" width="49%" elevation="0"
                 @click="deletarPermissao(dadosDeletar.idDoc); listarAutorizacoes();">Confirmar
          </v-btn>
          <v-spacer/>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogQrcode" max-width="500" width="100%" scrollable>
      <v-card>
        <v-card-title class="primary white--text">
          <v-row no-gutters>
            <v-col cols="12">
              <div class="d-flex">
                <span>Acesso de link via QR Code</span>
                <v-spacer/>
                <v-btn color="white" icon @click="closeDialogQrcode()" class="mb-n6" large>
                  <v-icon> mdi-close</v-icon>
                </v-btn>
              </div>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-bold text-subtitle-2 mb-0">{{ labelSubtitulo }}</p>
            </v-col>
          </v-row>
        </v-card-title>
        <v-divider/>
        <v-card-text class="text-center pa-10">
          <v-container v-show="carregandoQrcode" max-width="480" width="100%">
            <v-progress-circular class="my-16 y-16" size="200" color="black" width="6"
                                 indeterminate></v-progress-circular>
          </v-container>
          <v-dialog-transition leave-absolute>
            <canvas
                v-show="!carregandoQrcode"
                style="border: 6px solid black; width: 100%; max-width: 400px; height: auto;"
                ref="qrcodeCanvas"
            />
          </v-dialog-transition>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="12">
        <v-card class="primary">
          <v-card-title class="pa-0">
            <v-tabs v-model="tab" grow color="red darken-3" background-color="primary" dark class="pa-0">
              <v-tabs-slider color="red"></v-tabs-slider>
              <v-tab href="#tab-1" class="primary red--text" v-if="moduloLiberado">
                <v-icon color="red">mdi-receipt-text-plus-outline</v-icon>
                <span class="ml-2">Gerar Recibo</span>
              </v-tab>
              <v-tab href="#tab-2" class="primary red--text ml-3">
                <v-icon color="red">mdi-account-multiple-plus-outline</v-icon>
                <span class="ml-2">Relacionar Terceiro</span>
              </v-tab>
            </v-tabs>
          </v-card-title>
          <v-card-text>
            <v-tabs-items v-model="tab" class="pa-0">
              <v-tab-item v-if="moduloLiberado" value="tab-1">
                <v-card>
                  <div>
                    <v-divider/>
                    <v-progress-linear indeterminate absolute :active="carregando2"/>
                    <v-card-title class="title">
                      <v-row no-gutters>
                        <v-col cols="3" class="d-none d-md-block pr-1">
                          <InputDatePicker
                              :disabled="carregando"
                              v-model="busca.dtinicio"
                              label="Data inicial"
                              :outlined="true"
                              :dense="true"
                          />
                        </v-col>
                        <v-col cols="3" class="d-none d-md-block px-1">
                          <InputDatePicker
                              :disabled="carregando"
                              v-model="busca.dtfim"
                              label="Data final"
                              :outlined="true"
                              :dense="true"
                          />
                        </v-col>
                        <v-col cols="3" class="d-none d-md-block px-1">
                          <v-select
                              :items="filiaisFiltro"
                              item-text="filial"
                              item-value="idfilial"
                              label="Filial"
                              outlined
                              dense
                              :disabled="carregando"
                              v-model="busca.idfilial"
                              @change="dadosLista=[];totais={};"
                          ></v-select>
                        </v-col>
                        <v-bottom-sheet class="d-flex d-md-none" v-model="sheet">
                          <v-sheet class="text-center" height="100%">
                            <v-row class="pa-3">
                              <v-col cols="6" class="mb-n3 px-2">
                                <InputDatePicker
                                    :disabled="carregando"
                                    v-model="busca.dtinicio"
                                    label="Data inicial"
                                    :outlined="true"
                                    :dense="true"
                                />
                              </v-col>
                              <v-col cols="6" class="mb-n3 px-2">
                                <InputDatePicker
                                    :disabled="carregando"
                                    v-model="busca.dtfim"
                                    label="Data final"
                                    :outlined="true"
                                    :dense="true"
                                />
                              </v-col>
                              <v-col cols="6" class="mb-n3 px-2">
                                <v-select
                                    hide-details
                                    :items="filiaisFiltro"
                                    item-text="filial"
                                    item-value="idfilial"
                                    label="Filial"
                                    outlined
                                    dense
                                    :disabled="carregando"
                                    v-model="busca.idfilial"
                                    @change="dadosLista=[];totais={};"
                                ></v-select>
                              </v-col>
                              <v-col cols="6" class="mb-n5 px-2">
                                <v-text-field
                                    :disabled="carregando"
                                    v-model="busca.busca"
                                    label="Buscar"
                                    outlined
                                    dense
                                    @keydown.enter="listarPedidos(0)"
                                />
                              </v-col>
                              <v-col cols="6">
                                <v-btn width="100%" text class="mt-n3" color="error" @click="sheet = !sheet">Cancelar
                                </v-btn>
                              </v-col>
                              <v-col cols="6">
                                <v-btn width="100%" class="mt-n3" color="primary"
                                       @click="listarPedidos(0); sheet = !sheet">
                                  Filtrar
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-sheet>
                        </v-bottom-sheet>
                        <v-col class="pl-1">
                          <v-text-field
                              class="d-flex d-md-none mt-4"
                              :disabled="carregando"
                              v-model="busca.busca"
                              label="Buscar"
                              outlined
                              dense
                              @keydown.enter="listarPedidos(0)"
                              append-outer-icon="mdi-menu"
                              @click:append-outer="sheet = !sheet"
                              hide-details
                          />
                          <v-text-field
                              class="d-none d-md-block"
                              :disabled="carregando"
                              v-model="busca.busca"
                              label="Buscar"
                              outlined
                              dense
                              @keydown.enter="listarPedidos(0)"
                              hide-details
                          />
                        </v-col>
                        <v-col cols="auto" class="ml-2 mt-0">
                          <v-btn
                              :disabled="carregando"
                              class="mt-1"
                              color="primary"
                              elevation="0"
                              fab
                              x-small
                              @click="listarPedidos(0)"
                          >
                            <v-icon>mdi-magnify</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card-title>
                    <v-col cols="12" class="pa-0">
                      <v-divider/>
                    </v-col>

                    <v-card-text class="pt-0 px-0" v-if="$vuetify.breakpoint.mdAndUp">
                      <v-skeleton-loader v-if="carregandoSkeleton" type="table-tbody"/>
                      <v-simple-table v-else>
                        <template v-slot:default>
                          <thead>
                          <tr>
                            <th class="text-left">Filial</th>
                            <th class="text-truncate">Documento</th>
                            <th class="text-left">Cliente</th>
                            <th class="text-left">Data pedido</th>
                            <th class="text-left">Ponto de retirada</th>
                            <th class="text-center">Vinculo com Terceiro</th>
                            <th class="text-center pl-0">Situação Recibo</th>
                          </tr>
                          </thead>
                          <tbody>
                          <template v-if="dadosPedidosLista.total > 0">
                            <tr v-for="(u, i) in dadosPedidosLista.lista" :key="i">
                              <td>{{ u.filial }}</td>
                              <td class="text-truncate">
                                {{ u.idpedido }}
                              </td>
                              <td>{{ u.cliente }}</td>
                              <td>{{ u.dataPedido | formataData }}</td>
                              <td>{{ u.pontoRet }}</td>
                              <td class="text-center" width="300px">
                                <div class="mr-2">
                                  <v-btn
                                      rounded
                                      small
                                      color="orange darken-1"
                                      class="white--text"
                                      @click="listarProfissional(u.idclifor, u.cliente)"
                                  >
                                    <v-icon
                                        left
                                        color="white"
                                    >mdi-account-group
                                    </v-icon>
                                    Profissionais relacionados
                                  </v-btn>
                                </div>
                              </td>
                              <td class="text-center pl-0" width="260px">
                                <div class="mr-2" v-if="verificaRecibo(u.idclifor) === 'F'">
                                  <v-btn
                                      rounded
                                      small
                                      color="primary"
                                      class="white--text"
                                      @click="openDialogGerarRecibo(u.cliente, u.idpedido, u.dataPedido)"
                                  >
                                    <v-icon
                                        left
                                        color="white"
                                    >mdi-receipt-text-plus-outline
                                    </v-icon>
                                    Gerar recibo
                                  </v-btn>
                                </div>
                                <div class="mr-2" v-else>
                                  <v-btn
                                      rounded
                                      small
                                      color="green darken-1"
                                      class="white--text"
                                  >
                                    <v-icon
                                        left
                                        color="white"
                                    >mdi-receipt-text-check-outline
                                    </v-icon>
                                    Ver Recibo assinado
                                  </v-btn>
                                </div>
                              </td>
                            </tr>
                          </template>
                          <template v-else>
                            <tr>
                              <td class="text-center" colspan="7">Nenhum registro encontrado.</td>
                            </tr>
                          </template>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-card-text>
                  </div>
                  <v-divider/>
                  <Paginacao
                      class="py-3"
                      :total="dadosPedidosLista.total"
                      :pg="pgSelecionada"
                  />
                  <v-progress-linear indeterminate absolute :active="carregando"/>
                </v-card>
              </v-tab-item>
              <v-tab-item value="tab-2">
                <v-card>
                  <v-card-title>
                    <h3>Permissões Cadastradas</h3>
                    <v-spacer/>
                    <v-btn
                        primary
                        outlined
                        @click="dialogGerarPermissao = true"
                    >
                      Cadastrar Permissão
                    </v-btn>
                  </v-card-title>
                  <v-divider/>
                  <v-row no-gutters class="py-3 px-2">
                    <v-col cols="3" class="d-none d-md-block pr-1">
                      <InputDatePicker
                          :disabled="carregando"
                          v-model="busca.dtinicio"
                          label="Data inicial"
                          :outlined="true"
                          :dense="true"
                      />
                    </v-col>
                    <v-col cols="3" class="d-none d-md-block px-1">
                      <InputDatePicker
                          :disabled="carregando"
                          v-model="busca.dtfim"
                          label="Data final"
                          :outlined="true"
                          :dense="true"
                      />
                    </v-col>
                    <v-col cols="3" class="d-none d-md-block px-1">
                      <v-select
                          :items="filiaisFiltro"
                          item-text="filial"
                          item-value="idfilial"
                          label="Filial"
                          outlined
                          dense
                          :disabled="carregando"
                          v-model="busca.idfilial"
                      ></v-select>
                    </v-col>
                    <v-bottom-sheet class="d-flex d-md-none" v-model="sheet">
                      <v-sheet class="text-center" height="100%">
                        <v-row class="pa-3">
                          <v-col cols="6" class="mb-n3 px-2">
                            <InputDatePicker
                                :disabled="carregando"
                                v-model="busca.dtinicio"
                                label="Data inicial"
                                :outlined="true"
                                :dense="true"
                            />
                          </v-col>
                          <v-col cols="6" class="mb-n3 px-2">
                            <InputDatePicker
                                :disabled="carregando"
                                v-model="busca.dtfim"
                                label="Data final"
                                :outlined="true"
                                :dense="true"
                            />
                          </v-col>
                          <v-col cols="12" class="mb-n8 px-2">
                            <v-select
                                :items="filiaisFiltro"
                                item-text="filial"
                                item-value="idfilial"
                                label="Filial"
                                outlined
                                dense
                                :disabled="carregando"
                                v-model="busca.idfilial"
                            ></v-select>
                          </v-col>
                          <v-col cols="12" class="mb-n5 px-2">
                            <v-text-field
                                :disabled="carregando"
                                v-model="busca.busca"
                                label="Buscar"
                                outlined
                                dense
                                @keydown.enter="listarAutorizacoes(0)"
                            />
                          </v-col>
                          <v-col cols="6">
                            <v-btn width="100%" text class="mt-n3" color="error" @click="sheet = !sheet">Cancelar
                            </v-btn>
                          </v-col>
                          <v-col cols="6">
                            <v-btn width="100%" class="mt-n3" color="primary"
                                   @click="listarAutorizacoes(0); sheet = !sheet">
                              Filtrar
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-sheet>
                    </v-bottom-sheet>
                    <v-col class="pl-1">
                      <v-text-field
                          class="d-flex d-md-none mt-4"
                          :disabled="carregando"
                          v-model="busca.busca"
                          label="Buscar"
                          outlined
                          dense
                          @keydown.enter="listarAutorizacoes(0)"
                          append-outer-icon="mdi-menu"
                          @click:append-outer="sheet = !sheet"
                          hide-details
                      />
                      <v-text-field
                          class="d-none d-md-block"
                          :disabled="carregando"
                          v-model="busca.busca"
                          label="Buscar"
                          outlined
                          dense
                          @keydown.enter="listarAutorizacoes(0)"
                          hide-details
                      />
                    </v-col>
                    <v-col cols="auto" class="ml-2 mt-0">
                      <v-btn
                          :disabled="carregando"
                          class="mt-1"
                          color="primary"
                          elevation="0"
                          fab
                          x-small
                          @click="listarAutorizacoes(0)"
                      >
                        <v-icon>mdi-magnify</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-divider/>
                  <v-card-text class="pa-0">
                    <template v-if="$vuetify.breakpoint.smAndDown">
                      <v-card
                          v-for="item in paginatedItems"
                          :key="item.idautorizacao"
                          class="ma-2"
                      >
                        <v-card-title>ID: {{ item.idautorizacao }}</v-card-title>
                        <v-card-text>
                          <div><strong>Cliente:</strong> {{ item.cliente }}</div>
                          <div><strong>Terceiro:</strong> {{ item.nome }}</div>
                          <div><strong>Tipo:</strong> <span v-if="item.tipo_contrato === 'F' ">Contrato Físico</span>
                            <span v-if="item.tipo_contrato === 'D' ">Contrato Digital</span></div>
                          <div><strong>Status:</strong>
                            <v-btn small class="ml-1" :style="getBotaoStyle(item.status_geral, item.dtvalidade)"
                                   @click="abrirDialogPendente(item)">
                              {{ statusContrato(item.status_geral, item.dtvalidade) }}
                            </v-btn>
                          </div>
                        </v-card-text>
                        <v-card-actions>
                          <v-btn icon @click="uploadContrato(item)">
                            <v-icon color="primary"
                                    :disabled="item.status_geral === 'A'">mdi-file-upload-outline
                            </v-icon></v-btn>
                          <v-btn icon @click="renovarTermo(item)">
                            <v-icon
                                color="primary"
                                :disabled="item.status_geral === 'P'"
                            >mdi-autorenew</v-icon></v-btn>
                          <v-btn icon @click="visualizarDocumento(item, 'P')">
                            <v-icon
                                color="primary" :disabled="item.status_geral === 'P'"
                            >mdi-file-eye-outline</v-icon></v-btn>
                          <v-btn icon @click="getDelete(item)">
                            <v-icon color="red">mdi-trash-can-outline</v-icon></v-btn>
                        </v-card-actions>
                      </v-card>
                      <!-- Paginação -->
                      <v-pagination
                          v-model="currentPage"
                          :length="pageCount"
                          class="mt-4"
                          circle
                          total-visible="5"
                      />
                    </template>
                    <template v-else>
                      <v-data-table v-if="listaContratosPermissao.total > 0" :headers="[
                        { text: 'IdContrato', value: 'idautorizacao', class: 'text-no-wrap', sortable: false },
                        { text: 'Filial', value: 'filial', class: 'text-no-wrap', sortable: false },
                        { text: 'Cliente', value: 'cliente', class: 'text-no-wrap', sortable: false },
                        { text: 'Terceiro', value: 'nome', class: 'text-no-wrap', sortable: false },
                        { text: 'Tel. Terceiro', value: 'celular', class: 'text-no-wrap', sortable: false },
                        { text: 'Data Cadastro', value: 'dtcadastro', class: 'text-no-wrap', sortable: false },
                        { text: 'Data Validade', value: 'dtvalidade', class: 'text-no-wrap', sortable: false },
                        { text: 'Tipo', value: 'tipo_contrato', class: 'text-no-wrap', sortable: false },
                        { text: 'Status', value: 'status', class: 'text-no-wrap', sortable: false },
                        { text: 'Ações', value: 'botaoVisualizarPermissao', class: 'text-no-wrap', align: 'center', sortable: false },]"
                                    :items="listaContratosPermissao.lista"
                                    item-key="idautorizacao" class="elevation-0" :items-per-page="50"
                                    mobile-breakpoint="0"
                                    hide-default-footer>

                        <template v-slot:item.idautorizacao="{ item }">
                          <span class="pr-0">{{ item.idautorizacao }}</span>
                        </template>

                        <template v-slot:item.cliente="{ item }">
                          <span class="pr-0">{{ item.cliente }}</span>
                        </template>

                        <template v-slot:item.nome="{ item }">
                          {{ item.nome }}
                        </template>

                        <template v-slot:item.celular="{ item }">
                          {{ item.celular }}
                        </template>

                        <template v-slot:item.dtcadastro="{ item }">
                          {{ item.dtcadastro }}
                        </template>

                        <template v-slot:item.dtvalidade="{ item }">
                          {{ item.dtvalidade }}
                        </template>

                        <template v-slot:item.tipo_contrato="{ item }">
                          <span v-if="item.tipo_contrato === 'F' ">Contrato Físico</span>
                          <span v-if="item.tipo_contrato === 'D' ">Contrato Digital</span>
                        </template>

                        <template v-slot:item.status="{ item }">
                          <v-btn
                              rounded
                              small
                              :style="getBotaoStyle(item.status_geral, item.dtvalidade)"
                              @click="abrirDialogPendente(item)"
                          >
                            {{ statusContrato(item.status_geral, item.dtvalidade) }}
                          </v-btn>
                        </template>

                        <template v-slot:item.botaoVisualizarPermissao="{ item }">
                          <v-tooltip top color="primary">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon class="ml-2"
                                      @click="uploadContrato(item)"
                                      color="primary"
                                      size="20"
                                      :disabled="item.status_geral === 'A'"
                                      v-bind="attrs"
                                      v-on="on">mdi-file-upload-outline
                              </v-icon>
                            </template>
                            <span>Enviar contrato</span>
                          </v-tooltip>

                          <v-tooltip top color="primary">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                  class="ml-2"
                                  @click="renovarTermo(item)"
                                  color="primary" :disabled="item.status_geral === 'P'"
                                  size="20"
                                  v-bind="attrs"
                                  v-on="on">mdi-autorenew
                              </v-icon>
                            </template>
                            <span>Renovar validade contrato</span>
                          </v-tooltip>

                          <v-tooltip top color="primary">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                  class="ml-2"
                                  @click="visualizarDocumento(item, 'P')"
                                  color="primary" :disabled="item.status_geral === 'P'"
                                  size="20"
                                  v-bind="attrs"
                                  v-on="on">mdi-file-eye-outline
                              </v-icon>
                            </template>
                            <span>Visualizar documento</span>
                          </v-tooltip>

                          <v-tooltip top color="error">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                  class="ml-2"
                                  @click="getDelete(item)"
                                  color="red darken-3"
                                  size="20"
                                  v-bind="attrs"
                                  v-on="on">mdi-trash-can-outline
                              </v-icon>
                            </template>
                            <span>Deletar autorização</span>
                          </v-tooltip>
                        </template>

                      </v-data-table>
                      <v-data-table v-else
                                    hide-default-footer
                      >
                        <span class="white--text align-center">Nenhuma informação encontrada</span>
                      </v-data-table>
                    </template>

                  </v-card-text>
                </v-card>


              </v-tab-item>

            </v-tabs-items>

          </v-card-text>
        </v-card>
      </v-col>


    </v-row>
  </div>
</template>

<script>
import {mapState} from "vuex";
import axios from "axios";
import mixinFilial from "../../util/mixinFilial";
import Paginacao from "../Widgets/Paginacao";
import CardDialog from "../Widgets/CardDialog";
import InputDatePicker from "../Widgets/InputDatePicker";
import jsPDF from "jspdf";
import QRCode from "qrcode";
import autoTable from "jspdf-autotable";
import { PDFDocument } from "pdf-lib";
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';

export default {
  name: "ContratoPermissaoTerceiros",
  mixins: [mixinFilial],
  components: {CardDialog, Paginacao, InputDatePicker, VuePdfEmbed},
  data: () => ({
    dataDoc: new Date().getDate() + " de " +
        new Intl.DateTimeFormat('pt-BR', {month: 'long'}).format(new Date()) + " de " + new Date().getFullYear(),

    tab: null,
    e1: 1,

    // paginacao para mobile
    currentPage: 1,
    itemsPage: 10,

    obsRenovacao: null,
    dtvalidadeRenovacao: `${new Date(new Date().setMonth(new Date().getMonth() + 3))
        .toISOString()
        .slice(0, 10)}`,

    // para visualizacao do documento
    componentKey: 0,
    isPanning: false,
    delayZoom: false,
    pdfImageSrc: null,
    pdfSrc:null,
    zoomLevel: 2,
    containerWidth: '100%',
    minZoomWidth: 100,
    maxZoomWidth: 200,
    maxHeight: window.innerHeight - 190,
    ///////

    dataSugerida: '',

    itemsPerPageArray: [4, 8, 12],
    search: '',
    sortBy: 'nome',
    page: 1,
    itemsPerPage: 4,
    sortDesc: false,
    itemsTeste: [
      {
        nome: 'Mariana Costa',
        tipoProfissional: 'Arquiteto',
        dataValidade: '2025-04-22',
      },
      {
        nome: 'Pedro Lima',
        tipoProfissional: 'Pintor',
        dataValidade: '2025-04-30',
      },
      {
        nome: 'Carla Mendes',
        tipoProfissional: 'Mestre de Obra',
        dataValidade: '2025-02-05',
      },
      {
        nome: 'Fernanda Almeida',
        tipoProfissional: 'Arquiteto',
        dataValidade: '2025-07-08',
      },
      {
        nome: 'Lucas Oliveira',
        tipoProfissional: 'Engenheiro',
        dataValidade: '2025-10-29',
      },
      {
        nome: 'Gustavo Ferreira',
        tipoProfissional: 'Pedreiro',
        dataValidade: '2025-01-20',
      },
    ],

    moduloLiberado: false,

    aguardarBusca: null,
    aguardarBuscaCliente: null,
    aguardarBuscaTerceiro: null,
    searchProfissional: null,
    searchTerceiro: null,
    terceirosLista: [],
    searchCliente: null,
    clientesLista: [],
    profissionaisGestor: {
      lista: [],
      input: []
    },
    novoAutorizado: 'F',
    verificaAutorizado: 'N',

    terceirosAssinar: [
      {
        idclifor: 975,
        terceiro: 'Mariana Costa',
        tipo: 'Arquiteto',
        nome: 'Mariana Costa - Arquiteto',
        cpf: 69874523145
      },
      {
        idclifor: 723,
        terceiro: 'Pedro Lima',
        tipo: 'Pintor',
        nome: 'Pedro Lima - Pintor',
        cpf: 32471568912
      },
      {
        idclifor: 12858,
        terceiro: 'Fernanda Almeida',
        tipo: 'Engenheiro',
        nome: 'Fernanda Almeida - Engenheiro',
        cpf: 98742318961
      },
    ],
    dadosGerarPermissao: {
      permissaoGerada: false,
      retornoCadastro: false,
      dadosTerceiro: {
        idclifor: null,
        nome: null,
        telefone: null,
        tipoProfissional: '',
        cpf: null,
        dataValidade: `${new Date(new Date().setMonth(new Date().getMonth() + 3))
            .toISOString()
            .slice(0, 10)}`,
        tipoRelacionamento: '',
        idCadastroAut: null,
      },
      dadosCliente: {
        idclifor: null,
        telefone: null,
        email: null,
        cpf: null,
        endereco: null,
        numero: null,
        bairro: null,
        cidade: null,
        cep: null,
        uf: null,
      }
    },
    dadosGerarRecibo: {
      idclifor: null,
      nomeClienteRecibo: null,
      pedidoRecibo: null,
      dataPedidoRecibo: null,
      terceiroSelecionado: null,

      valorRecibo: 565.60,
      reciboGerado: false,
      produtosRecibo: [
        {
          idsubproduto: 123,
          produto: 'Tijolo',
          qtd: '20',
          valor: '0.28',
          valorTot: '5.6'
        },
        {
          idsubproduto: 456,
          produto: 'Cimento',
          qtd: '10',
          valor: '40',
          valorTot: '400'
        },
        {
          idsubproduto: 789,
          produto: 'Argamassa',
          qtd: '4',
          valor: '40.00',
          valorTot: '160.0'
        },
      ],
      dadosTerceiro: {
        idclifor: null,
        nome: null,
        telefone: null,
        tipoProfissional: null,
        cpf: null,
        dataValidade: null,
      },
      dadosCliente: {
        idclifor: null,
        telefone: null,
        email: null,
        cpf: null,
        endereco: null,
        numero: null,
        bairro: null,
        cidade: null,
        cep: null,
        uf: null,
      }
    },

    retornoDocOnline: {
      retorno: false,
      linkRecibo: 'https://asdhgkajshdjkashduiwakjdnaciucasasldjhasiud/asdjnaskd_4564a2s1d56',
      statusAssinatura: 'NA'
    },
    profissionaisCliente: [],
    qtdProfissionalCliente: null,
    clienteNome: null,

    tipoRelacionamento: [],
    tipoProfissional: [],
    qtdProfissionais: [
      {
        idclifor: 6545,
        qtd: 0
      },
      {
        idclifor: 156,
        qtd: 3
      },
      {
        idclifor: 983,
        qtd: 0
      },
      {
        idclifor: 347,
        qtd: 2
      },
    ],
    dadosPedidosLista: {
      lista: [
        {
          idfilial: 1,
          filial: 'Ivaiporã',
          idpedido: 65456,
          idclifor: 6545,
          cliente: 'Cliente 1',
          pontoRet: 'Cliente Retira',
          dataPedido: '2025-02-02',
          reciboAssinado: 'T',
        },
        {
          idfilial: 1,
          filial: 'Ivaiporã',
          idpedido: 65456,
          idclifor: 156,
          cliente: 'Cliente 2',
          pontoRet: 'Cliente Retira',
          dataPedido: '2025-02-02',
          reciboAssinado: 'F',
        },
        {
          idfilial: 1,
          filial: 'Ivaiporã',
          idpedido: 65456,
          idclifor: 983,
          cliente: 'Cliente 3',
          pontoRet: 'Cliente Retira',
          dataPedido: '2025-02-02',
          reciboAssinado: 'F',
        },
        {
          idfilial: 1,
          filial: 'Ivaiporã',
          idpedido: 65456,
          idclifor: 347,
          cliente: 'Cliente 4',
          pontoRet: 'Cliente Retira',
          dataPedido: '2025-02-02',
          reciboAssinado: 'P',
        }
      ],
      total: 4
    },

    isVisible: false,
    isVisible2: false,

    pdfUrl: null,
    //empresasPiloto: [1, 3],
    ultimaEmpresa: 0,
    dialogProfissionais: false,
    dialogDocumentoAssinado: false,
    dialogGerarPermissao: false,
    dialogGerarRecibo: false,
    dialogDocPendente: false,
    dialogRenovaTermo: false,
    dialogTermoFisico: false,
    dialogDeletar: false,
    dialogQrcode: false,
    dialogAviso: false,
    dialogErro: {
      status: false,
      title: "",
      msg: "",
      icon: "",
      iconColor: "",
    },

    sheet: false,
    snackbar: {status: false, timeout: 3000, color: 'red'},

    carregando: false,
    carregandoQrcode: false,
    carregandoSkeleton: false,
    carregandoTotais: true,


    carregando1: false,
    carregando2: false,
    carregando3: false,

    listaContratosPermissao: {
      lista: [],
      total: 0
    },

    dadosPendente: {
      idautorizacao: null,
      cliente: '',
      autorizado: '',
      dtcadastro: '',
      dtvalidade: '',
      hashCliente: '',
      hashProfissional: '',
      statusAssinaturaCliente: '',
      statusAssinaturaProfissional: '',
      statusGeral: '',
      hashArq: '',
      tipoContrato: '',
    },
    dadosFisico:{},


    labelSubtitulo: '',


    step: 1,
    tipoDoc: null,
    pedidoDoc: null,

    dadosDeletar: {
      idfilial: null,
      filial: null,
      idDoc: null,
      clienteDoc: null,
      profissionalDoc: null,
      dtcadastro: null,
      dtvalidade: null
    },


    dados: {},
    imagens: [],
    arquivos: [],
    contratoPDF: "",
    diretorio: "",
    base64PDF: "",
    urlPDF: "",
    ArquivoBlob: "",
    arquivoSelecionado: null,
    linksPermissao: {
      linkCliente: '',
      linkProfissional: ''
    },

    dadosLista: {},
    totais: {},
    busca: {
      dtinicio: `${new Date().getFullYear()}-${
          (new Date(
              new Date().getFullYear(),
              new Date().getMonth() + 1,
              0
          ).getMonth() +
          1 <
          10
              ? "0"
              : "") +
          (new Date().getMonth() + 1)
      }-01`,
      dtfim: `${new Date(
          new Date().getFullYear(),
          new Date().getMonth() + 1,
          0
      ).getFullYear()}-${
          (new Date(
              new Date().getFullYear(),
              new Date().getMonth() + 1,
              0
          ).getMonth() +
          1 <
          10
              ? "0"
              : "") +
          (new Date().getMonth() + 1)
      }-${new Date(
          new Date().getFullYear(),
          new Date().getMonth() + 1,
          0
      ).getDate()}`,
      idstatus: null,
      idsituacao: null,
      idorcamento: null,
      idcliente: null,
      idfilial: null,
      busca: '',
    },
    pgSelecionada: 0,

    validarTelefone: [
      value => {
        if (!value) return 'Campo obrigatório.';
        if (value.length >= 15) return true
        return 'O número informado deve ser válido.';
      },
    ],
    validarEmail: [
      value => {
        if (!value) return 'Campo obrigatório.';
        if (/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value)) return true
        return 'O e-mail informado deve ser válido.'
      },
    ],
    validarData: [
      valor => {
        if (!valor) return 'A data é obrigatória';

        const hoje = new Date();
        hoje.setHours(0, 0, 0, 0);

        // Converter "dd/mm/yyyy" para "yyyy-mm-dd"
        const partes = valor.split('/');
        if (partes.length !== 3) return 'Data inválida';

        const valorISO = `${partes[2]}-${partes[1]}-${partes[0]}`; // yyyy-mm-dd
        const data = new Date(valorISO + "T00:00:00");
        data.setHours(0, 0, 0, 0);

        if (data < hoje) {
          return 'A data não pode ser anterior à data atual';
        }

        return true; // válido
      }
    ],
    dataValida: false,
  }),
  computed: {
    ...mapState(["backendUrl", "pgLimit", "usuario"]),
    filiaisFiltro() {
      if (this.filiais.lista) {
        return this.filiais.lista.filter((v) => {
          return (
              v.idfilial !== 6 &&
              v.idfilial !== 12 &&
              v.idfilial !== 25 &&
              v.idfilial !== 29 &&
              v.idfilial !== 33 &&
              v.idfilial !== 37
          );
        });
      } else {
        return [];
      }
    },

    /// paginacao manual para mobile
    pageCount() {
      return Math.ceil(this.listaContratosPermissao.total / this.itemsPage);
    },
    paginatedItems() {
      const start = (this.currentPage - 1) * this.itemsPage;
      return this.listaContratosPermissao.lista.slice(start, start + this.itemsPage);
    },

    ///
    itemsClientes() {
      if (this.clientesLista == null) return;

      this.clientesLista.forEach((cliente) => {
        if (cliente.nome.length > this.nomeLimit) {
          cliente.nome =
              cliente.nome.slice(0, this.nomeLimit) + "...";
        }
      });

      return this.clientesLista;
    },
    itemsTerceiros() {
      if (this.terceirosLista == null) return;

      this.terceirosLista.forEach((terceiro) => {
        if (terceiro.nome.length > this.nomeLimit) {
          terceiro.nome =
              terceiro.nome.slice(0, this.nomeLimit) + "...";
        }
      });

      return this.terceirosLista;
    },
    numberOfPages() {
      return Math.ceil(this.itemsTeste.length / this.itemsPerPage)
    },
    validaTerceiro() {
      return this.dadosGerarRecibo.terceiroSelecionado
    },
    validaClientePermissao() {
      return this.dadosGerarPermissao.dadosCliente.idclifor && this.dadosGerarPermissao.dadosCliente.telefone
    },
    validaDadosTotalPermissao() {
      return this.dadosGerarPermissao.dadosTerceiro.nome &&
          this.dadosGerarPermissao.dadosTerceiro.telefone &&
          this.cpfValido(this.dadosGerarPermissao.dadosTerceiro.cpf) &&
          this.dadosGerarPermissao.dadosCliente.idclifor &&
          this.dadosGerarPermissao.dadosCliente.telefone &&
          (this.dadosGerarPermissao.dadosCliente.idclifor !== this.dadosGerarPermissao.dadosTerceiro.idclifor) &&
          (this.dadosGerarPermissao.dadosTerceiro.tipoProfissional || this.dadosGerarPermissao.dadosTerceiro.tipoRelacionamento)
    },
    validaTerceiroRules() {
      return [
        valor => {
          if (valor === this.dadosGerarPermissao.dadosCliente.idclifor) {
            return 'O cliente selecionado já está vinculado e não pode ser escolhido como terceiro.';
          }
          return true;
        }
      ];
    }


  },
  methods: {
    adicionarArquivo(arquivos) {
      if (arquivos) {
        const arquivosArray = Array.isArray(arquivos) ? arquivos : [arquivos];
        this.arquivos = [];

        arquivosArray.forEach((arquivo) => {
          let obj = {};
          obj.tipo = arquivo.name.split(".").pop();

          let reader = new FileReader();
          reader.readAsDataURL(arquivo);

          reader.onload = (event) => {
            obj.arquivo = event.target.result.split("base64,")[1];
            this.arquivos.push(obj);
          };
        });
      } else {
        this.arquivoSelecionado = null;
        this.arquivos = [];
      }
    },
    async enviarContrato() {
      this.carregando = true;
      return axios
          .post(`${this.backendUrl}autorizacao/terceiro/termo/envia`, {
            idautorizacao: this.dadosPendente.idautorizacao,
            arquivo: this.arquivos[0].arquivo,
            tipo: this.arquivos[0].tipo,
          })
          .then((res) => {
            if (res.data) {
              this.dialogErro.title = "Sucesso";
              this.dialogErro.msg = "Contrato enviado com sucesso";
              this.dialogErro.icon = "mdi-check-circle-outline";
              this.dialogErro.iconColor = "success";
              this.dialogErro.status = true;
            }
            this.carregando = false;
            this.dialogTermoFisico = false;
            this.listarAutorizacoes();
            this.arquivos = [];
            this.arquivoSelecionado = null;
          })
          .catch((e) => {
            this.dialogErro.title = "Erro";
            if (e.response.data.erro) {
              this.dialogErro.msg = e.response.data.erro;
            } else {
              this.dialogErro.msg =
                  "Não foi possível realizar o cadastro do contrato!";
            }
            this.dialogErro.icon = "mdi-alert-circle-outline";
            this.dialogErro.iconColor = "red";
            this.dialogErro.status = true;
          });
    },

    async buscaArquivo(hash, tipo, idautorizacao){
      this.carregando=true;
      this.pdfBase64 = null;
      this.imagens = [];
      return axios
          .post(`${this.backendUrl}autorizacao/terceiro/buscar`, {
            hash: hash,
            idautorizacao: idautorizacao
          })
          .then((res) => {
            if(tipo === 'D'){
              this.pdfBase64 = res.data;
            }else{
              this.imagens.push(res.data);
            }
            this.carregando=false;
          })
          .catch((e) => {
            this.carregando = false;
            this.dialogErro.title = "Falha ao assinar!";
            if (e.response.data.erro) {
              this.dialogErro.msg = `Falha ao buscar contrato atualizado, \n favor reportar (${e.response.data.erro})`;
            } else {
              this.dialogErro.msg =
                  `Falha ao buscar contrato atualizado`;
            }
            this.dialogErro.icon = "mdi-alert-circle-outline";
            this.dialogErro.iconColor = "red";
            this.dialogErro.status = true
            this.carregando=false;
          });
    },

    async converterBase64ParaBlob(base64, mimeType = 'application/pdf') {
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      return new Blob([byteArray], { type: mimeType });
    },

    getBotaoStyle(status, dtvalidade) {
      if (dtvalidade) {
        const hoje = new Date();
        hoje.setHours(0, 0, 0, 0);

        // dtvalidade no formato DD/MM/YYYY
        const [dia, mes, ano] = dtvalidade.split('/');
        const dataValidade = new Date(ano, mes - 1, dia);
        dataValidade.setHours(0, 0, 0, 0);

        if (dataValidade < hoje) {
          return { backgroundColor: '#a80000', color: '#fff' }; // Vencida (Vermelho)
        }
      }

      const styleMap = {
        P: { backgroundColor: '#FFA500', color: '#fff' }, // Pendente (Laranja)
        A: { backgroundColor: '#28a745', color: '#fff' }  // Vigente (Verde)
      };

      return styleMap[status] || {};
    },

    formataCPF(numeros) {
      const numerosF = numeros.toString().replace(/\D/g, '');

      return numerosF.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    },
    cpfValido(cpf) {
      return cpf.length === 14;
    },
    emailEhValido(email) {
      if (!email) return false;

      const regexEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      return regexEmail.test(email);
    },
    statusContrato(status, dtvalidade) {
      if (!dtvalidade) return 'Sem validade';

      const hoje = new Date();
      hoje.setHours(0, 0, 0, 0);

      // dtvalidade no formato DD/MM/YYYY
      const [dia, mes, ano] = dtvalidade.split('/');
      const dataValidade = new Date(ano, mes - 1, dia);
      dataValidade.setHours(0, 0, 0, 0);

      if (dataValidade < hoje) {
        return 'Vencida';
      }

      const statusMap = {
        A: 'Vigente',
        P: 'Pendente'
      };

      return statusMap[status] || 'Status desconhecido';
    },
    uploadContrato(doc){
      if(doc === 'Fechar'){
        this.dadosPendente.idautorizacao = null
        this.dadosPendente.cliente = ''
        this.dadosPendente.autorizado = ''
        this.dadosPendente.dtcadastro = ''
        this.dadosPendente.dtvalidade = ''
        this.arquivoSelecionado = null
        this.arquivos = [];

        this.dialogTermoFisico = false;
      }else{
        this.dadosPendente.idautorizacao = doc.idautorizacao
        this.dadosPendente.cliente = doc.cliente
        this.dadosPendente.autorizado = doc.nome
        this.dadosPendente.dtcadastro = doc.dtcadastro
        this.dadosPendente.dtvalidade = doc.dtvalidade

        this.dialogTermoFisico = true;
      }
    },
    renovarTermo(doc) {

      if(doc === 'Fechar'){
        this.dadosPendente.idautorizacao = null
        this.dadosPendente.cliente = ''
        this.dadosPendente.autorizado = ''
        this.dadosPendente.dtcadastro = ''
        this.dadosPendente.dtvalidade = ''
        this.obsRenovacao = ''
        this.dtvalidadeRenovacao = `${new Date(new Date().setMonth(new Date().getMonth() + 3))
            .toISOString()
            .slice(0, 10)}`
        this.dialogRenovaTermo = false;
      }else{
        // console.log(this.dadosPendente)
        this.dadosPendente.idautorizacao = doc.idautorizacao
        this.dadosPendente.cliente = doc.cliente
        this.dadosPendente.autorizado = doc.nome
        this.dadosPendente.dtcadastro = doc.dtcadastro
        this.dadosPendente.dtvalidade = doc.dtvalidade

        this.dialogRenovaTermo = true;
      }

    },
    atualizarValidade(){
      this.carregando2 = true;
      return axios
          .post(`${this.backendUrl}autorizacao/terceiro/renovar_validade`, {
            idautorizacao: this.dadosPendente.idautorizacao,
            dtvalidade: this.dtvalidadeRenovacao,
            observacao: this.obsRenovacao,
          })
          .then((res) => {

            if(res.data.success){
              this.dialogErro.title = "Sucesso";
              this.dialogErro.msg = res.data.msg;
              this.dialogErro.icon = "mdi-check-circle-outline";
              this.dialogErro.iconColor = "success";
              this.dialogErro.status = true;
            }else{
              this.dialogErro.title = "Erro";
              this.dialogErro.msg = res.data.msg;
              this.dialogErro.icon = "mdi-alert-circle-outline";
              this.dialogErro.iconColor = "error";
              this.dialogErro.status = true;
            }
            this.carregando2 = false;
            this.listarAutorizacoes();
            this.dialogRenovaTermo = false;
          })
          .catch((res) => {
            this.dialogErro.title = "Erro";
            this.dialogErro.msg = res.data.msg;
            this.dialogErro.icon = "mdi-alert-circle-outline";
            this.dialogErro.iconColor = "error";
            this.dialogErro.status = true;
            this.carregando2 = false;
          });
    },
    async visualizarDocumento(doc, tipo) {
      this.tipoDoc = tipo;
      let id = doc.idautorizacao;
      if (tipo === 'P') {
        this.clienteDoc = doc.cliente;
      }

      await this.buscaArquivo(doc.hash_terceiro, doc.tipo_contrato, id)

      if(doc.tipo_contrato === 'F'){
        this.pdfSrc = null
      }else{
        const blob = await this.converterBase64ParaBlob(this.pdfBase64)
        this.pdfSrc = URL.createObjectURL(blob)
      }

      this.dialogDocumentoAssinado = true;
    },
    getDelete(item) {
      this.dadosDeletar.idDoc = item.idautorizacao;
      this.dadosDeletar.filial = item.filial;
      this.dadosDeletar.clienteDoc = item.cliente;
      this.dadosDeletar.profissionalDoc = item.nome;
      this.dadosDeletar.dtcadastro = item.dtcadastro;
      this.dadosDeletar.dtvalidade = item.dtvalidade;
      this.dialogDeletar = true;
    },
    formataDataDocumento(data) {
      return this.usuario.filial + ', ' + data
    },

    formatarTelefoneProfissional() {
      let numero = this.dadosGerarRecibo.dadosTerceiro.telefone.replace(/\D/g, ''); // Remove tudo que não for número

      // Limita o número a no máximo 11 dígitos (para suportar telefones com 9 dígitos no Brasil)
      numero = numero.slice(0, 11);

      if (numero.length > 10) {
        this.dadosGerarRecibo.dadosTerceiro.telefone = numero.replace(/^(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
      } else {
        this.dadosGerarRecibo.dadosTerceiro.telefone = numero.replace(/^(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3');
      }
    },
    carregarClientes(val) {
      clearTimeout(this.aguardarBuscaCliente);
      this.aguardarBuscaCliente = setTimeout(() => {
        this.carregando2 = true;
        return axios
            .post(`${this.backendUrl}cliente/listar`, {
              limit: 30,
              offset: 0,
              busca: val || null,
            })
            .then((res) => {
              this.clientesLista = res.data.lista.map((v) => {
                return {
                  ...v,
                  idenome: `${v.idcliente} - ${v.nome}`,
                  telefone: `${v.telefoneComercial}`
                };
              });
              this.carregando2 = false;
            })
            .catch(() => {
              this.carregando2 = false;
            });
      }, this.timeLimit);
    },
    carregarTerceiros(val) {
      clearTimeout(this.aguardarBuscaTerceiro);
      this.aguardarBuscaTerceiro = setTimeout(() => {
        this.carregando3 = true;
        return axios
            .post(`${this.backendUrl}cliente/listar`, {
              limit: 30,
              offset: 0,
              busca: val || null,
            })
            .then((res) => {
              this.terceirosLista = res.data.lista.map((v) => {
                return {
                  ...v,
                  idenome: `${v.idcliente} - ${v.nome}`,
                  telefone: `${v.telefoneComercial}`
                };
              });
              this.carregando3 = false;
            })
            .catch(() => {
              this.carregando3 = false;
            });
      }, this.timeLimit);
    },
    carregarProfissional(val) {
      clearTimeout(this.aguardarBusca);
      this.aguardarBusca = setTimeout(() => {
        this.carregando2 = true;
        return axios
            .post(`${this.backendUrl}dashboard/controle/visitaclientelistar`, {
              busca: val || '',
            })
            .then((res) => {
              this.profissionaisGestor.lista = JSON.parse(res.data.NOME);
              this.profissionaisGestor.input = this.profissionaisGestor.lista.map((v) => {
                return {
                  ...v,
                  idenome: `${v.NOME}`
                };
              });
              this.carregando2 = false;
            })
            .catch(() => {
              this.carregando2 = false;
            });
      }, this.timeLimit);
    },
    listaTipoProfissional() {
      this.tipoProfissional = [];
      this.carregando = true;
      return axios
          .post(`${this.backendUrl}dashboard/controle/visitatipoprofissional`, {})
          .then((res) => {
            this.tipoProfissional = JSON.parse(res.data.tipoprofissional) || [];
            this.carregando = false;
          })
          .catch(() => {
            this.carregando = false;
          });
    },
    listaTipoRelacionamento() {
      this.tipoRelacionamento = [];
      this.carregando = true;
      return axios
          .post(`${this.backendUrl}autorizacao/relacionamento/listar`, {})
          .then((res) => {
            this.tipoRelacionamento = res.data.lista || [];
            this.carregando = false;
          })
          .catch(() => {
            this.carregando = false;
          });
    },
    verificaProfissionais(id) {
      const profissionais = this.qtdProfissionais.find(item => item.idclifor === id);
      return profissionais ? profissionais.qtd : 0;
    },
    verificaRecibo(id) {
      const validaRecibo = this.dadosPedidosLista.lista.find(item => item.idclifor === id);
      return validaRecibo.reciboAssinado;
    },
    openDialogGerarRecibo(nome, idpedido, data) {
      this.dadosGerarRecibo.nomeClienteRecibo = nome;
      this.dadosGerarRecibo.pedidoRecibo = idpedido;
      this.dadosGerarRecibo.dataPedidoRecibo = data;
      this.dialogGerarRecibo = true;
    },
    cadastrarProfissional() {
      return axios
          .post(`${this.backendUrl}profissional/terceiro/cadastrar`, {
            idprofissionalciss: this.dadosGerarPermissao.dadosTerceiro.idclifor,
            nome: this.dadosGerarPermissao.dadosTerceiro.nome,
            celular: this.dadosGerarPermissao.dadosTerceiro.telefone,
            cnpjcpf: this.dadosGerarPermissao.dadosTerceiro.cpf,
            idtipoprofissional: this.dadosGerarPermissao.dadosTerceiro.tipoProfissional || 10,
            idtiporelacionamento: this.dadosGerarPermissao.dadosTerceiro.tipoRelacionamento || 0,
          })
          .then((res) => {
            this.dadosGerarPermissao.dadosTerceiro.idCadastroAut = res.data.idprofissional
            this.dadosGerarPermissao.retornoCadastro = res.data.success;
            this.dialogErro.title = "Sucesso";
            this.dialogErro.msg = res.data.msg;
            this.dialogErro.icon = "mdi-check-circle-outline";
            this.dialogErro.iconColor = "success";
            this.dialogErro.status = true;
            this.carregando2 = false;

          })
          .catch((res) => {
            this.dialogErro.title = "Erro";
            this.dialogErro.msg = res.data.msg;
            this.dialogErro.icon = "mdi-check-circle-outline";
            this.dialogErro.iconColor = "error";
            this.dadosGerarPermissao.retornoCadastro = res.data.success;
            this.dialogErro.status = true;
            this.carregando2 = false;
          });
    },
    cadastrarAutorizacao(blobOriginal) {
      return axios
          .post(`${this.backendUrl}autorizacao/terceiro/cadastrar/links`, {
            idprofissionalciss: this.dadosGerarPermissao.dadosTerceiro.idclifor,
            idprofissional: this.dadosGerarPermissao.dadosTerceiro.idCadastroAut,
            idcliente: this.dadosGerarPermissao.dadosCliente.idclifor,
            dtvalidade: this.dadosGerarPermissao.dadosTerceiro.dataValidade,
            arquivo_original: blobOriginal,
            arquivo_assinado: blobOriginal,
          })
          .then((res) => {
            this.linksPermissao.linkCliente = res.data.linkcliente
            this.linksPermissao.linkProfissional = res.data.linkprofissional
            this.carregando2 = false;
          })
          .catch((res) => {
            this.dialogErro.title = "Erro";
            this.dialogErro.msg = res.data.msg;
            this.dialogErro.icon = "mdi-check-circle-outline";
            this.dialogErro.iconColor = "error";
            this.dadosGerarPermissao.retornoCadastro = res.data.success;
            this.dialogErro.status = true;
            this.carregando2 = false;
          });
    },
    listarProfissional(id, nome) {
      this.dialogProfissionais = true;
      this.profissionaisCliente = [];
      this.qtdProfissionalCliente = this.verificaProfissionais(id);
      this.clienteNome = nome;
      this.carregando3 = true;
      return axios
          .post(`${this.backendUrl}permissoes/cliente/profissionais/listar`, {
            idclifor: id
          })
          .then((res) => {
            this.profissionaisCliente = res.data || [];
            this.carregando3 = false;
          })
          .catch(() => {
            this.carregando3 = false;
          });
    },

    buscaLinkPendente() {
      return axios
          .post(`${this.backendUrl}autorizacao/terceiro/busca/links`, {
            idautorizacao: this.dadosPendente.idautorizacao
          })
          .then((res) => {
            this.dadosPendente.statusAssinaturaCliente = res.data.status_cliente
            this.dadosPendente.statusAssinaturaProfissional = res.data.status_profissional
            this.dadosPendente.statusGeral = res.data.status_geral
            this.dadosPendente.hashCliente = res.data.linkcliente
            this.dadosPendente.hashProfissional = res.data.linkprofissional
            this.carregando = false;
          })
          .catch(() => {
            this.carregando = false;
          });
    },

    gerarLinkRecibo() {
      this.step = 2;
      this.retornoDocOnline.retorno = true;
      this.gerarRecibo();
    },

    async abrirDialogPendente(doc) {

      if(doc === 'Fechar'){
        this.dadosPendente.idautorizacao = null
        this.dadosPendente.cliente = ''
        this.dadosPendente.autorizado = ''
        this.dadosPendente.dtcadastro = ''
        this.dadosPendente.dtvalidade = ''
        this.dadosPendente.statusAssinaturaCliente = ''
        this.dadosPendente.statusAssinaturaProfissional = ''
        this.dadosPendente.hashArq = ''
        this.dadosPendente.tipoContrato = ''

        this.listarAutorizacoes();

        this.dialogDocPendente = false;
      }else{
        this.dadosPendente.idautorizacao = doc.idautorizacao
        this.dadosPendente.cliente = doc.cliente
        this.dadosPendente.autorizado = doc.nome
        this.dadosPendente.dtcadastro = doc.dtcadastro
        this.dadosPendente.dtvalidade = doc.dtvalidade
        this.dadosPendente.statusAssinaturaCliente = doc.status_cliente
        this.dadosPendente.statusAssinaturaProfissional = doc.status_profissional
        this.dadosPendente.hashArq = doc.hash_terceiro
        this.dadosPendente.tipoContrato = doc.tipo_contrato

        await this.buscaLinkPendente();

        this.dialogDocPendente = true
      }

    },

    async gerarLinkPermissao() {
      this.e1 = 3;
      await this.cadastrarProfissional();
      await this.gerarPermissao();
      //await this.listarAutorizacoes();

    },
    listarPedidos() {

    },
    listarAutorizacoes() {
      this.listaContratosPermissao.lista = [];
      this.listaContratosPermissao.total = 0;
      return axios
          .post(`${this.backendUrl}autorizacao/terceiro/listar`, {
            dtinicio: this.busca.dtinicio,
            dtfim: this.busca.dtfim,
            busca: this.busca.busca,
            idfilial: this.busca.idfilial,
            limit: 99999,
            offset: 99999,
          })
          .then((res) => {
            this.$set(this.listaContratosPermissao, 'lista', res.data.lista);
            this.$set(this.listaContratosPermissao, 'total', res.data.total);
            this.currentPage = 1;
            this.carregando = false;
          })
          .catch(() => {
            this.carregando = false;
          });
    },

    // Função para adicionar a assinatura no PDF
    async adicionarAssinaturaPdf(jsPdfBlob, signatureBase64, user, tipo) {
      try {
        // Converter o Blob do PDF para ArrayBuffer
        const arrayBuffer = await jsPdfBlob.arrayBuffer();

        // Carregar o PDF com pdf-lib
        const pdfDoc = await PDFDocument.load(arrayBuffer);

        const base64SemPrefixo = signatureBase64.split(",")[1];

        // Converter assinatura Base64 para bytes
        const signatureBytes = Uint8Array.from(
            atob(base64SemPrefixo),
            (char) => char.charCodeAt(0)
        );

        // Incorporar a imagem da assinatura ao PDF
        const signatureImage = await pdfDoc.embedPng(signatureBytes);

        // Adicionar a assinatura à última página
        const pages = pdfDoc.getPages();
        const firstPage = pages[0];
        const secondPage = pages[1];
        //const lastPage = pages[pages.length - 1];

        const pageWidth = firstPage.getWidth(); // largura da página
        const signatureWidth = 152;
        const signatureHeight = 57;
        const x = (pageWidth - signatureWidth) / 2;
        const y = 220; // Ajuste conforme necessário
        const y2 = 150; // Ajuste conforme
        const y3 = 75; // Ajuste conforme

        if(tipo === 'F'){
          /// assinatura contrato fisico
          firstPage.drawImage(signatureImage, {
            x: x, // Posição X (em pontos)
            y: y3, // Posição Y (em pontos)
            width: signatureWidth, // Largura da assinatura
            height: signatureHeight, // Altura da assinatura
          });
        }else{
          switch (user) {
            case "C":
              firstPage.drawImage(signatureImage, {
                x: x, // Posição X (em pontos)
                y: y, // Posição Y (em pontos)
                width: signatureWidth, // Largura da assinatura
                height: signatureHeight, // Altura da assinatura
              });
              break;
            case "T":
              firstPage.drawImage(signatureImage, {
                x: x, // Posição X (em pontos)
                y: y2, // Posição Y (em pontos)
                width: signatureWidth, // Largura da assinatura
                height: signatureHeight, // Altura da assinatura
              });
              break;
            case "D1":
              firstPage.drawImage(signatureImage, {
                x: x, // Posição X (em pontos)
                y: y3, // Posição Y (em pontos)
                width: signatureWidth, // Largura da assinatura
                height: signatureHeight, // Altura da assinatura
              });

              secondPage.drawImage(signatureImage, {
                x: 350, // Posição X (em pontos)
                y: 630, // Posição Y (em pontos)
                width: signatureWidth, // Largura da assinatura
                height: signatureHeight, // Altura da assinatura
              });
              break;
            default:
              break;
          }
        }


        // Salvar o PDF com a assinatura
        const pdfBytes = await pdfDoc.save();

        // Criar uma URL para o PDF assinado
        return new Blob([pdfBytes], { type: 'application/pdf' });

      } catch (error) {
        console.error("Erro ao adicionar assinatura:", error);
      }
    },


    gerarPermissao() {
      this.dadosGerarPermissao.permissaoGerada = true;
      setTimeout(async () => {
        const doc = new jsPDF("p", "pt", "a4");


        // Define as margens
        const marginLeft = 85; // 3cm em pontos
        const marginRight = 85;
        const pageWidth = doc.internal.pageSize.getWidth();
        const usableWidth = pageWidth - marginLeft - marginRight;

        // Adiciona a logo no topo (substitua com seu base64)
        const imagePath = require('@/assets/icons/logo_dark.png');
        const logoBase64 = await this.carregarImagemBase64(imagePath);
        doc.addImage(logoBase64, 'PNG', marginLeft, 40, usableWidth, 80); // altura 100pt

        // Espaço abaixo da imagem
        let y = 150;

        // Adiciona o título centralizado
        doc.setFontSize(14);
        doc.setFont("Helvetica", "bold");
        doc.text("TERMO DE AUTORIZAÇÃO PARA ENTREGA/RETIRADA DE MERCADORIA A TERCEIROS", marginLeft, y, {
          maxWidth: usableWidth,
        });

        y += 40;

        // Texto do termo (exemplo, substitua pelo seu texto real)
        const texto = `
        Eu, ${this.dadosGerarPermissao.dadosCliente?.nome}, inscrito(a) no CPF/CNPJ sob o n° ${this.formataCPF(this.dadosGerarPermissao.dadosCliente?.cpf)}, residente e domiciliado no endereço ${this.dadosGerarPermissao.dadosCliente?.endereco}, N° ${this.dadosGerarPermissao.dadosCliente?.numero} - ${this.dadosGerarPermissao.dadosCliente?.bairro} - ${this.dadosGerarPermissao.dadosCliente?.cidade},  ${this.dadosGerarPermissao.dadosCliente?.uf} autorizo o Senhor(a) ${this.dadosGerarPermissao.dadosTerceiro?.nome}, inscrito(a) no CPF sob o N° ${this.dadosGerarPermissao.dadosTerceiro?.cpf}, comprar, pedir, retirar e receber as mercadorias adquiridas na empresa COMERCIAL IVAIPORÃ LTDA., bem como assinar qualquer documentação necessária, desde que vinculada à respectiva compra (notas de entrega, notas de compra, entre outros).
        A presente autorização abrange as vendas e pedidos realizados presencialmente, bem como via telefone, os quais terão os termos e condições acordados através do referido contato.
        No momento da entrega das mercadorias, as notas de entrega, notas de compra  e demais documentos necessários serão devidamente assinados.

        Por ser expressão de verdade, firmo o presente.
        `;

        // Adiciona o texto com quebra de linha automática
        doc.setFontSize(12);
        doc.setFont("Helvetica", "normal");
        doc.text(doc.splitTextToSize(texto, usableWidth), marginLeft, y);

        /// adiciona data
        //const dataPermissao = `Ivaiporã, 30 de Abril de 2025.`;

        doc.setFontSize(12);
        doc.setFont("Helvetica", "bold");
        doc.text(`${this.formataDataDocumento(this.dataDoc)}.`, pageWidth / 2, 450, {
          align: "center",
        });

        // Posição inicial para as assinaturas (após o texto)
        let assinaturaY = doc.lastAutoTable ? doc.lastAutoTable.finalY + 60 : doc.internal.pageSize.getHeight() - 220;

        // Largura da linha de assinatura
        const linhaWidth = 300;

        // Altura entre linhas
        const espacoAssinatura = 70;

        // Array com os rótulos das assinaturas
        const assinaturas = [
          "Cliente",
          "Autorizado",
          "Comercial Ivaiporã LTDA."
        ];

        doc.setFontSize(12);
        doc.setFont("Helvetica", "bold");

        assinaturas.forEach((label, i) => {
          const y = assinaturaY + i * espacoAssinatura;

          // Centraliza horizontalmente
          const x = (pageWidth - linhaWidth) / 2;

          // Linha de assinatura
          doc.line(x, y, x + linhaWidth, y);

          // Texto abaixo da linha, também centralizado
          doc.text(label, x + linhaWidth / 2, y + 15, {align: "center"});
        });

        doc.setFillColor(0, 32, 96);
        doc.rect(0, 0, 8, doc.internal.pageSize.height, 'F');
        doc.setFont('helvetica', 'normal');


        // Adicionar segunda página
        let margin = 48
        doc.addPage();
        let yPos = 24;

        // Cabeçalho da terceira página
        doc.setFontSize(15);
        doc.setFont('helvetica', 'bold');
        doc.text("Relatório de Assinaturas", margin, yPos); // Título
        doc.setFontSize(8);
        doc.setFont('helvetica', 'normal');
        yPos += 14;
        doc.text("Datas e horários em UTC-0300 ( America/Sao_Paulo )", margin, yPos);
        yPos += 12;
        doc.text(``, margin, yPos);

        // Adicionar imagem (logo)
        //const imagePath = require('@/assets/icons/logo_dark.png');
        doc.addImage(imagePath, "PNG", 415, 13, 160, 28); // Ajuste as coordenadas (x, y, largura, altura) conforme necessário

        yPos += 10;
        doc.setDrawColor(200, 200, 200); // RGB (valores altos criam tons mais claros)
        doc.setLineWidth(0.2);
        doc.line(0, yPos, pageWidth, yPos); // Desenha a linha

        yPos += 16;

        doc.setFontSize(9);

        doc.text('' +
            'Documento: Termo de Autorização para Entrega/Retirada de Mercadoria a Terceiros\n' +
            `Data da criação: ${this.formatDate()}\n` +
            '', margin, yPos);

        yPos += 52;

        doc.line(0, yPos, pageWidth, yPos); // Desenha a linha


        yPos += 16;

        doc.setFontSize(12);
        doc.setFont('helvetica', 'bold');
        doc.text("Assinaturas", margin + 277, yPos, {align: 'center'}); // Título

        yPos += 10;

        doc.setFillColor(0, 32, 96);
        doc.rect(0, 0, 8, doc.internal.pageSize.height, 'F');

        // Empresa
        doc.setFillColor(0, 32, 96);
        doc.rect(0, 0, 8, doc.internal.pageSize.height, 'F');

        autoTable(doc, {
          startY: yPos,
          tableLineColor: [200, 200, 200],
          tableLineWidth: 0.5,
          head: [
            [
              {
                content: 'Assinado',
                colSpan: 3,
                styles: {
                  halign: 'center',
                  fontStyle: 'bold',
                  fontSize: 8,
                  textColor: [35, 142, 35],
                  lineColor: [255, 255, 255],
                  fillColor: [219, 234, 213]
                }
              },
              {
                content: 'Assinatura',
                colSpan: 2,
                styles: {halign: 'left', fontStyle: 'normal', fontSize: 8, lineColor: [255, 255, 255]}
              }
            ]
          ],
          body: [
            [
              {
                content: `JULIANO DE CARVALHO GIL`,
                colSpan: 3,
                styles: {
                  halign: 'left',
                  fontStyle: 'bold',
                  fontSize: 11,
                  font: 'courier',
                  overflow: 'hidden',
                  cellPadding: {top: 9, right: 6, bottom: 3, left: 6}
                }
              },
              {
                content: ``,
                colSpan: 2,
                styles: {fontStyle: 'normal', fontSize: 8}
              },
            ],
            [
              {
                content: `Data e hora da assinatura: ${this.formatDate(1)}`,
                colSpan: 3,
                styles: {halign: 'left', fontStyle: 'normal'}
              },
              {
                content: `JULIANO DE CARVALHO GIL`,
                colSpan: 2,
                styles: {fontStyle: 'normal', fontSize: 7}
              },
            ],
            [
              {
                content: `Pontos de autenticação:`,
                colSpan: 5,
                styles: {halign: 'left', fontStyle: 'bold', cellPadding: {top: 6, right: 6, bottom: 2, left: 6}}
              },
            ],
            [
              {
                content:
                    `IP: 200.195.165.115\n` +
                    `Dispositivo: Go-http-client/2.0`,
                colSpan: 3,
                styles: {halign: 'left', fontStyle: 'normal', cellPadding: {top: 0, right: 6, bottom: 6, left: 6}}
              }
            ],
          ],
          styles: {
            fontSize: 8,
            cellPadding: 6,
            lineColor: [255, 255, 255],
            lineWidth: 0.1,
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0]
          },
          margin: {top: 10, left: 15, right: 15, bottom: 10},
          columnStyles: {
            0: {cellWidth: 150},
            1: {cellWidth: 150},
            2: {cellWidth: 35},
            3: {cellWidth: 180},
            4: {cellWidth: 40},
          },
          theme: 'grid',
          didDrawCell: (data) => {
            if (data.row.index === 0) {
              doc.setDrawColor(222, 222, 222);
              doc.setLineWidth(1);
              if (data.column.index === 0 || data.column.index === 1 || data.column.index === 2) {
                doc.line(data.cell.x, data.cell.y, data.cell.x + data.cell.width, data.cell.y);
              }
            }
            if (data.row.index === 0 || data.row.index === 1) {
              doc.setDrawColor(200, 200, 200);
              doc.setLineWidth(1);
              if (data.column.index === 3) {
                doc.line(data.cell.x, data.cell.y - 0.5, data.cell.x, data.cell.y + data.cell.height + 1);
              }

            }
            if (data.row.index === 2) {
              doc.setDrawColor(200, 200, 200);
              doc.setLineWidth(1);
              doc.line(data.cell.x, data.cell.y, data.cell.x + data.cell.width, data.cell.y);
            }
          },
        });

        yPos += 130;

        // Cliente
        autoTable(doc, {
          startY: yPos,
          tableLineColor: [200, 200, 200],
          tableLineWidth: 0.5,
          head: [
            [
              {
                content: 'Pendente', colSpan: 3, styles:
                    {
                      halign: 'center',
                      fontStyle: 'bold',
                      fontSize: 8,
                      textColor: [255, 140, 0],
                      lineColor: [255, 255, 255],
                      fillColor: [255, 240, 218]
                    }
              },
              {
                content: 'Assinatura',
                colSpan: 2,
                styles: {halign: 'left', fontStyle: 'normal', fontSize: 8, lineColor: [255, 255, 255]}
              }
            ]
          ],
          body: [
            [
              {
                content: `${this.dadosGerarPermissao.dadosCliente.nome}`,
                colSpan: 3,
                styles: {
                  halign: 'left',
                  fontStyle: 'bold',
                  fontSize: 11,
                  font: 'courier',
                  overflow: 'hidden',
                  cellPadding: {top: 9, right: 6, bottom: 3, left: 6}
                }
              },
              {
                content: ``,
                colSpan: 2,
                styles: {fontStyle: 'normal', fontSize: 8}
              },
            ],
            [
              {
                content: `Data e hora da assinatura:`,
                colSpan: 3,
                styles: {halign: 'left', fontStyle: 'normal'}
              },
            ],
            [
              {
                content: `Pontos de autenticação:`,
                colSpan: 1,
                styles: {halign: 'left', fontStyle: 'bold', cellPadding: {top: 6, right: 6, bottom: 2, left: 6}}
              },
              {
                content:
                    ``,
                colSpan: 4,
                styles: {halign: 'left', fontStyle: 'normal', cellPadding: {top:6, right:6, bottom:2, left:6}}
              }
            ],
            [
              {
                content:
                    `Localização aproximada:`,
                colSpan: 1,
                styles: {halign: 'left', fontStyle: 'normal', cellPadding: {top: 0, right: 6, bottom: 0, left: 6}}
              },
              {
                content:
                    `Telefone:`,
                colSpan: 3,
                styles: {halign: 'left', fontStyle: 'normal', cellPadding: {top: 0, right: 6, bottom: 0, left: 6}}
              },
              {
                content:
                    `IP:`,
                colSpan: 1,
                styles: {halign: 'left', fontStyle: 'normal', cellPadding: {top: 0, right: 6, bottom: 0, left: 6}}
              }
            ],
            [
              {
                content:
                    `Dispositivo:`,
                colSpan: 5,
                styles: {halign: 'left', fontStyle: 'normal', cellPadding: {top: 2, right: 6, bottom: 14, left: 6}}
              }
            ],
          ],
          styles: {
            fontSize: 8,
            cellPadding: 6,
            lineColor: [255, 255, 255],
            lineWidth: 0.1,
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0]
          },
          margin: {top: 10, left: 15, right: 15, bottom: 10},
          columnStyles: {
            0: {cellWidth: 220},
            1: {cellWidth: 80},
            2: {cellWidth: 35},
            3: {cellWidth: 40},
            4: {cellWidth: 180},
          },
          theme: 'grid',
          didDrawCell: (data) => {
            if (data.row.index === 0) {
              doc.setDrawColor(222, 222, 222);
              doc.setLineWidth(1);
              if (data.column.index === 0 || data.column.index === 1 || data.column.index === 2) {
                doc.line(data.cell.x, data.cell.y, data.cell.x + data.cell.width, data.cell.y);
              }
            }
            if (data.row.index === 0 || data.row.index === 1) {
              doc.setDrawColor(200, 200, 200);
              doc.setLineWidth(1);
              if (data.column.index === 3) {
                doc.line(data.cell.x, data.cell.y - 0.5, data.cell.x, data.cell.y + data.cell.height + 1);
              }

            }
            if (data.row.index === 2) {
              doc.setDrawColor(200, 200, 200);
              doc.setLineWidth(1);
              doc.line(data.cell.x, data.cell.y, data.cell.x + data.cell.width, data.cell.y);
            }
          },
        });

        yPos += 130;

        /// Terceiro
        autoTable(doc, {
          startY: yPos,
          tableLineColor: [200, 200, 200],
          tableLineWidth: 0.5,
          head: [
            [
              {
                content: 'Pendente', colSpan: 3, styles:
                    {
                      halign: 'center',
                      fontStyle: 'bold',
                      fontSize: 8,
                      textColor: [255, 140, 0],
                      lineColor: [255, 255, 255],
                      fillColor: [255, 240, 218]
                    }
              },
              {
                content: 'Assinatura',
                colSpan: 2,
                styles: {halign: 'left', fontStyle: 'normal', fontSize: 8, lineColor: [255, 255, 255]}
              }
            ]
          ],
          body: [
            [
              {
                content: `${this.dadosGerarPermissao.dadosTerceiro.nome}`,
                colSpan: 3,
                styles: {
                  halign: 'left',
                  fontStyle: 'bold',
                  fontSize: 11,
                  font: 'courier',
                  overflow: 'hidden',
                  cellPadding: {top: 9, right: 6, bottom: 3, left: 6}
                }
              },
              {
                content: ``,
                colSpan: 2,
                styles: {fontStyle: 'normal', fontSize: 8}
              },
            ],
            [
              {
                content: `Data e hora da assinatura:`,
                colSpan: 3,
                styles: {halign: 'left', fontStyle: 'normal'}
              },
            ],
            [
              {
                content: `Pontos de autenticação:`,
                colSpan: 1,
                styles: {halign: 'left', fontStyle: 'bold', cellPadding: {top: 6, right: 6, bottom: 2, left: 6}}
              },
              {
                content:
                    ``,
                colSpan: 4,
                styles: {halign: 'left', fontStyle: 'normal', cellPadding: {top:6, right:6, bottom:2, left:6}}
              }
            ],
            [
              {
                content:
                    `Localização aproximada:`,
                colSpan: 1,
                styles: {halign: 'left', fontStyle: 'normal', cellPadding: {top: 0, right: 6, bottom: 0, left: 6}}
              },
              {
                content:
                    `Telefone:`,
                colSpan: 3,
                styles: {halign: 'left', fontStyle: 'normal', cellPadding: {top: 0, right: 6, bottom: 0, left: 6}}
              },
              {
                content:
                    `IP:`,
                colSpan: 1,
                styles: {halign: 'left', fontStyle: 'normal', cellPadding: {top: 0, right: 6, bottom: 0, left: 6}}
              }
            ],
            [
              {
                content:
                    `Dispositivo:`,
                colSpan: 5,
                styles: {halign: 'left', fontStyle: 'normal', cellPadding: {top: 2, right: 6, bottom: 14, left: 6}}
              }
            ],
          ],
          styles: {
            fontSize: 8,
            cellPadding: 6,
            lineColor: [255, 255, 255],
            lineWidth: 0.1,
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0]
          },
          margin: {top: 10, left: 15, right: 15, bottom: 10},
          columnStyles: {
            0: {cellWidth: 220},
            1: {cellWidth: 80},
            2: {cellWidth: 35},
            3: {cellWidth: 40},
            4: {cellWidth: 180},
          },
          theme: 'grid',
          didDrawCell: (data) => {
            if (data.row.index === 0) {
              doc.setDrawColor(222, 222, 222);
              doc.setLineWidth(1);
              if (data.column.index === 0 || data.column.index === 1 || data.column.index === 2) {
                doc.line(data.cell.x, data.cell.y, data.cell.x + data.cell.width, data.cell.y);
              }
            }
            if (data.row.index === 0 || data.row.index === 1) {
              doc.setDrawColor(200, 200, 200);
              doc.setLineWidth(1);
              if (data.column.index === 3) {
                doc.line(data.cell.x, data.cell.y - 0.5, data.cell.x, data.cell.y + data.cell.height + 1);
              }

            }
            if (data.row.index === 2) {
              doc.setDrawColor(200, 200, 200);
              doc.setLineWidth(1);
              doc.line(data.cell.x, data.cell.y, data.cell.x + data.cell.width, data.cell.y);
            }
          },
        });

        doc.save("permissao.pdf");

        // gerar arquivo
        // Gera o Blob do PDF e cria uma URL
        const pdfBlobOriginal = doc.output("blob");

        let pdfBlobAssinado = await this.adicionarAssinaturaPdf(pdfBlobOriginal, 'data:image/png;base64,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', 'D1')

        const base64PDF1 = await this.converterBlobParaBase64(pdfBlobAssinado)
        this.cadastrarAutorizacao(base64PDF1)
        this.urlPDF = URL.createObjectURL(pdfBlobAssinado);

      }, 100);
      this.listarAutorizacoes(0);
    },
    gerarRecibo() {
      this.dadosGerarRecibo.reciboGerado = true;
      const produtos = this.dadosGerarRecibo.produtosRecibo;
      setTimeout(async () => {
        const doc = new jsPDF("p", "pt", "a4");


        // Define as margens
        const marginLeft = 85; // 3cm em pontos
        const marginRight = 85;
        const pageWidth = doc.internal.pageSize.getWidth();
        const usableWidth = pageWidth - marginLeft - marginRight;

        //let y = 120;

        // Adiciona a logo no topo (substitua com seu base64)
        const imagePath = require('@/assets/icons/logo_dark.png');
        const logoBase64 = await this.carregarImagemBase64(imagePath);
        doc.addImage(logoBase64, 'PNG', marginLeft, 20, usableWidth, 80); // altura 100pt


        autoTable(doc, {
          startY: 120,
          head: [
            [{
              content: 'RECIBO DE RETIRADA DE MERCADORIAS',
              colSpan: 5,
              styles: {halign: 'center', fontStyle: 'bold', fontSize: 11}
            }]
          ],
          body: [
            [
              {
                content: `                   ${this.dadosGerarRecibo.dadosTerceiro.nome}\n                      ${this.formataCPF(this.dadosGerarRecibo.dadosTerceiro.cpf)}`,
                colSpan: 4,
                styles: {fontSize: 14, halign: 'left', fontStyle: 'normal', cellPadding: {top: 22}, overflow: 'hidden'}
              },
              {
                content: `\n ____________________________________\n                  Assinatura do Emitente`,
                styles: {fontSize: 9, halign: 'left', fontStyle: 'normal', cellPadding: {top: 45}}
              },
            ],
            [
              {
                content: `               ${this.dadosGerarRecibo.pedidoRecibo}`,
                colSpan: 3,
                styles: {halign: 'left', fontStyle: 'normal'}
              },
              {
                content: `          ${this.$options.filters.formataData(this.dadosGerarRecibo.dataPedidoRecibo)}`,
                styles: {halign: 'left', fontStyle: 'normal'}
              },
              {
                content: `            ${this.$options.filters.formataDinheiro(this.dadosGerarRecibo.valorRecibo)}`,
                styles: {halign: 'left', fontStyle: 'normal'}
              },
            ],
            [
              {
                content: `Eu, ${this.dadosGerarRecibo.dadosTerceiro.nome}, inscrito no CPF/CNPJ sob o N° ${this.formataCPF(this.dadosGerarRecibo.dadosTerceiro.cpf)}, declaro que recebi de COMERCIAL IVAIPORÃ LTDA., nesta data, as mercadorias referente ao pedido N° ${this.dadosGerarRecibo.pedidoRecibo}, especificadas abaixo.`,
                colSpan: 5,
                styles: {halign: 'left', fontStyle: 'normal'}
              },
            ],

          ],
          styles: {
            fontSize: 10,
            cellPadding: 4,
            lineColor: [0, 0, 0],
            lineWidth: 0.5,
          },
          headStyles: {
            fillColor: [200, 200, 210],
            textColor: [0, 0, 0]
          },
          margin: {top: 10, left: 15, right: 15, bottom: 10},
          columnStyles: {
            0: {cellWidth: 62},
            1: {cellWidth: 62},
            2: {cellWidth: 62},
            3: {cellWidth: 186},
            4: {cellWidth: 186},
            5: {cellWidth: 186},
          },
          theme: 'plain',
          didDrawCell: (data) => {
            doc.setFont('helvetica', 'bold');
            if (data.section === 'body' && data.row.index === 1) {
              if (data.column.index === 0) {
                doc.text('Pedido:', data.cell.x + 4, data.cell.y + 12);
              }

              if (data.column.index === 3) {
                doc.text('Data:', data.cell.x + 4, data.cell.y + 12);
              }

              if (data.column.index === 4) {
                doc.text('Valor:', data.cell.x + 4, data.cell.y + 12);
              }
            }

            if (data.section === 'body' && data.column.index === 0) {

              if (data.row.index === 0) {
                doc.text('Emitente:\nCNPJ/CPF: ', data.cell.x + 4, data.cell.y + 33);
              }

            }

            if (data.row.index === 2 || data.row.index === 3 || data.row.index === 4) {
              doc.setDrawColor(255, 255, 255);
              doc.setLineWidth(4);
              if (data.column.index === 4) {
                doc.line(data.cell.x, data.cell.y + 0.5, data.cell.x, data.cell.y + data.cell.height - 0.5);
              }
            }

            doc.setFillColor(0, 32, 96);
            doc.rect(0, 0, 8, doc.internal.pageSize.height, 'F');
            doc.setFont('helvetica', 'normal');
          },
        });

        const firstTable = doc.lastAutoTable;
        const startYProdutos = firstTable.finalY;

        //Tabela de produtos
        autoTable(doc, {
          startY: startYProdutos,
          head: [[
            'Ref.',
            'Produto',
            'Quantidade',
            'Valor Unitário',
            'Valor Total'
          ]],
          body: (produtos || []).map(item => [
            item.idsubproduto,
            item.produto,
            item.qtd.toLocaleString('pt-BR', {minimumFractionDigits: 2}),
            this.$options.filters.formataDinheiro(item.valor).toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL'
            }),
            this.$options.filters.formataDinheiro(item.qtd * item.valor).toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL'
            })
          ]),
          styles: {
            fontSize: 10,
            cellPadding: 4,
            lineColor: [0, 0, 0],
            lineWidth: 0.5,
          },
          headStyles: {
            fillColor: [200, 200, 210],
            textColor: [0, 0, 0]
          },
          margin: {top: 10, left: 15, right: 15, bottom: 10},
          theme: 'plain',
        });

        const produtosTable = doc.lastAutoTable;
        const startYDataLocal = produtosTable.finalY;

        autoTable(doc, {
          startY: startYDataLocal,
          body: [
            [
              {
                content: `                            ${this.$options.filters.formataDinheiro(this.dadosGerarRecibo.valorRecibo)}`,
                colSpan: 5,
                styles: {halign: 'left', fontStyle: 'normal'}
              }
            ],
            [
              {
                content: `                                          ${this.formataDataDocumento(this.dataDoc)}`,
                colSpan: 5,
                styles: {halign: 'left', fontStyle: 'normal'}
              }
            ]
          ],
          styles: {
            fontSize: 14,
            cellPadding: 8,
            lineColor: [0, 0, 0],
            lineWidth: 0.5,
          },
          margin: {top: 10, left: 15, right: 15, bottom: 10},
          theme: 'plain',

          didDrawCell: (data) => {
            doc.setFont('helvetica', 'bold');

            if (data.section === 'body' && data.column.index === 0) {
              if (data.row.index === 0) {
                doc.text('Valor do Recibo: ', data.cell.x + 4, data.cell.y + 20);
              }

              if (data.row.index === 1) {
                doc.text('Local e data de emissão: ', data.cell.x + 4, data.cell.y + 20);
              }
            }

          },

        });

        // Adicionar segunda página
        let margin = 48
        doc.addPage();
        let yPos = 24;

        // Cabeçalho da terceira página
        doc.setFontSize(15);
        doc.setFont('helvetica', 'bold');
        doc.text("Relatório de Assinaturas", margin, yPos); // Título
        doc.setFontSize(8);
        doc.setFont('helvetica', 'normal');
        yPos += 14;
        doc.text("Datas e horários em UTC-0300 ( America/Sao_Paulo )", margin, yPos);
        yPos += 12;
        doc.text(`Última atualização em ${this.formatDate()}`, margin, yPos);

        // Adicionar imagem (logo)
        // const imagePath = require('@/assets/icons/logo_dark.png');
        // doc.addImage(imagePath, "PNG", 415, 13, 160, 28); // Ajuste as coordenadas (x, y, largura, altura) conforme necessário

        yPos += 10;
        doc.setDrawColor(200, 200, 200); // RGB (valores altos criam tons mais claros)
        doc.setLineWidth(0.2);
        doc.line(0, yPos, pageWidth, yPos); // Desenha a linha

        yPos += 16;

        doc.setFontSize(9);

        doc.text('Status: Em-Curso\n' +
            'Documento: Recibo de Retirada de Mercadorias\n' +
            `Número: 33333333\n` +
            `Data da criação: ${this.formatDate()}\n` +
            'Hash do documento original (SHA256):', margin, yPos);

        yPos += 52;

        doc.line(0, yPos, pageWidth, yPos); // Desenha a linha


        yPos += 16;

        doc.setFontSize(12);
        doc.setFont('helvetica', 'bold');
        doc.text("Assinaturas", margin + 277, yPos, {align: 'center'}); // Título

        yPos += 10;

        doc.setFillColor(0, 32, 96);
        doc.rect(0, 0, 8, doc.internal.pageSize.height, 'F');

        autoTable(doc, {
          startY: yPos,
          tableLineColor: [200, 200, 200],
          tableLineWidth: 0.5,
          head: [
            [
              {
                content: 'Pendente', colSpan: 3, styles:
                    {
                      halign: 'center',
                      fontStyle: 'bold',
                      fontSize: 8,
                      textColor: [255, 140, 0],
                      lineColor: [255, 255, 255],
                      fillColor: [255, 240, 218]
                    }
              },
              {
                content: 'Assinatura',
                colSpan: 2,
                styles: {halign: 'left', fontStyle: 'normal', fontSize: 8, lineColor: [255, 255, 255]}
              }
            ]
          ],
          body: [
            [
              {
                content: `${this.dadosGerarRecibo.dadosTerceiro.nome}`,
                colSpan: 3,
                styles: {
                  halign: 'left',
                  fontStyle: 'bold',
                  fontSize: 11,
                  font: 'courier',
                  overflow: 'hidden',
                  cellPadding: {top: 9, right: 6, bottom: 3, left: 6}
                }
              },
              {
                content: ``,
                colSpan: 2,
                styles: {fontStyle: 'normal', fontSize: 8}
              },
            ],
            [
              {
                content: `Data e hora da assinatura:`,
                colSpan: 3,
                styles: {halign: 'left', fontStyle: 'normal'}
              },
              {
                content: `333333333`,
                colSpan: 2,
                styles: {fontStyle: 'normal', fontSize: 7, overflow: 'ellipsize'},
              },
            ],
            [
              {
                content: `Pontos de autenticação:`,
                colSpan: 1,
                styles: {halign: 'left', fontStyle: 'bold', cellPadding: {top: 6, right: 6, bottom: 2, left: 6}}
              },
              {
                content:
                    `E-mail:`,
                colSpan: 4,
                styles: {halign: 'left', fontStyle: 'normal', cellPadding: {top: 6, right: 6, bottom: 2, left: 6}}
              }
            ],
            [
              {
                content:
                    `Localização aproximada:`,
                colSpan: 1,
                styles: {halign: 'left', fontStyle: 'normal', cellPadding: {top: 0, right: 6, bottom: 0, left: 6}}
              },
              {
                content:
                    `Telefone:`,
                colSpan: 3,
                styles: {halign: 'left', fontStyle: 'normal', cellPadding: {top: 0, right: 6, bottom: 0, left: 6}}
              },
              {
                content:
                    `IP:`,
                colSpan: 1,
                styles: {halign: 'left', fontStyle: 'normal', cellPadding: {top: 0, right: 6, bottom: 0, left: 6}}
              }
            ],
            [
              {
                content:
                    `Dispositivo:`,
                colSpan: 5,
                styles: {halign: 'left', fontStyle: 'normal', cellPadding: {top: 2, right: 6, bottom: 14, left: 6}}
              }
            ],
          ],
          styles: {
            fontSize: 8,
            cellPadding: 6,
            lineColor: [255, 255, 255],
            lineWidth: 0.1,
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0]
          },
          margin: {top: 10, left: 15, right: 15, bottom: 10},
          columnStyles: {
            0: {cellWidth: 220},
            1: {cellWidth: 80},
            2: {cellWidth: 35},
            3: {cellWidth: 40},
            4: {cellWidth: 180},
          },
          theme: 'grid',
          didDrawCell: (data) => {
            if (data.row.index === 0) {
              doc.setDrawColor(222, 222, 222);
              doc.setLineWidth(1);
              if (data.column.index === 0 || data.column.index === 1 || data.column.index === 2) {
                doc.line(data.cell.x, data.cell.y, data.cell.x + data.cell.width, data.cell.y);
              }
            }
            if (data.row.index === 0 || data.row.index === 1) {
              doc.setDrawColor(200, 200, 200);
              doc.setLineWidth(1);
              if (data.column.index === 3) {
                doc.line(data.cell.x, data.cell.y - 0.5, data.cell.x, data.cell.y + data.cell.height + 1);
              }

            }
            if (data.row.index === 2) {
              doc.setDrawColor(200, 200, 200);
              doc.setLineWidth(1);
              doc.line(data.cell.x, data.cell.y, data.cell.x + data.cell.width, data.cell.y);
            }
          },
        });

        doc.save("recibo.pdf");

        // gerar arquivo
        const blob = doc.output("blob");
        const url = URL.createObjectURL(blob);
        window.open(url, "_blank");
      }, 100);
    },
    gerarContratoFisico(){
      setTimeout(async () => {
        const doc = new jsPDF("p", "pt", "a4");

        // Define as margens
        const marginLeft = 85; // 3cm em pontos
        const marginRight = 85;
        const pageWidth = doc.internal.pageSize.getWidth();
        const usableWidth = pageWidth - marginLeft - marginRight;

        // Adiciona a logo no topo (substitua com seu base64)
        const imagePath = require('@/assets/icons/logo_dark.png');
        const logoBase64 = await this.carregarImagemBase64(imagePath);
        doc.addImage(logoBase64, 'PNG', marginLeft, 40, usableWidth, 80); // altura 100pt

        // Espaço abaixo da imagem
        let y = 150;

        // Adiciona o título centralizado
        doc.setFontSize(14);
        doc.setFont("Helvetica", "bold");
        doc.text("TERMO DE AUTORIZAÇÃO PARA ENTREGA/RETIRADA DE MERCADORIA A TERCEIROS", marginLeft, y, {
          maxWidth: usableWidth,
        });

        y += 40;

        // Texto do termo (exemplo, substitua pelo seu texto real)
        const texto = `
        Eu, ${this.dadosFisico?.cliente}, inscrito(a) no CPF/CNPJ sob o n° ${this.formataCPF(this.dadosFisico?.cpf_cliente)}, residente e domiciliado no endereço ${this.dadosFisico?.endereco}, N° ${this.dadosFisico?.numero} - ${this.dadosFisico?.bairro} - ${this.dadosFisico?.cidade},  ${this.dadosFisico?.uf} autorizo o Senhor(a) ${this.dadosFisico?.profissional}, inscrito(a) no CPF sob o N° ${this.dadosFisico?.cpf_profissional}, comprar, pedir, retirar e receber as mercadorias adquiridas na empresa COMERCIAL IVAIPORÃ LTDA., bem como assinar qualquer documentação necessária, desde que vinculada à respectiva compra (notas de entrega, notas de compra, entre outros).
        A presente autorização abrange as vendas e pedidos realizados presencialmente, bem como via telefone, os quais terão os termos e condições acordados através do referido contato.
        No momento da entrega das mercadorias, as notas de entrega, notas de compra  e demais documentos necessários serão devidamente assinados.

        Por ser expressão de verdade, firmo o presente.
        `;

        // Adiciona o texto com quebra de linha automática
        doc.setFontSize(12);
        doc.setFont("Helvetica", "normal");
        doc.text(doc.splitTextToSize(texto, usableWidth), marginLeft, y);

        /// adiciona data
        //const dataPermissao = `Ivaiporã, 30 de Abril de 2025.`;

        doc.setFontSize(12);
        doc.setFont("Helvetica", "bold");
        doc.text(`${this.formataDataDocumento(this.dataDoc)}.`, pageWidth / 2, 450, {
          align: "center",
        });

        // Posição inicial para as assinaturas (após o texto)
        let assinaturaY = doc.lastAutoTable ? doc.lastAutoTable.finalY + 60 : doc.internal.pageSize.getHeight() - 220;

        // Largura da linha de assinatura
        const linhaWidth = 300;

        // Altura entre linhas
        const espacoAssinatura = 70;

        // Array com os rótulos das assinaturas
        const assinaturas = [
          "Cliente",
          "Autorizado",
          "Comercial Ivaiporã LTDA."
        ];

        doc.setFontSize(12);
        doc.setFont("Helvetica", "bold");

        assinaturas.forEach((label, i) => {
          const y = assinaturaY + i * espacoAssinatura;

          // Centraliza horizontalmente
          const x = (pageWidth - linhaWidth) / 2;

          // Linha de assinatura
          doc.line(x, y, x + linhaWidth, y);

          // Texto abaixo da linha, também centralizado
          doc.text(label, x + linhaWidth / 2, y + 15, {align: "center"});
        });

        doc.setFillColor(0, 32, 96);
        doc.rect(0, 0, 8, doc.internal.pageSize.height, 'F');
        doc.setFont('helvetica', 'normal');

        doc.save("permissao.pdf");

        // gerar arquivo
        // Gera o Blob do PDF e cria uma URL
        const pdfBlobOriginal = doc.output("blob");

        let pdfBlobAssinado = await this.adicionarAssinaturaPdf(pdfBlobOriginal, 'data:image/png;base64,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', 'D1', 'F')
        this.urlPDF = URL.createObjectURL(pdfBlobAssinado);
        window.open(this.urlPDF, "_blank");

      }, 100);

    },
    alteraContrato(){
      this.dadosFisico = {}
      return axios
          .post(`${this.backendUrl}autorizacao/terceiro/termo/alterar_tipo`, {
            idautorizacao: this.dadosPendente.idautorizacao
          })
          .then((res) => {
            this.dadosFisico = res.data;
            this.gerarContratoFisico();
            this.carregando = false;
            this.abrirDialogPendente('Fechar');
          })
          .catch(() => {
            this.carregando = false;
          });
    },
    deletarPermissao(idcontrato) {
      return axios
          .post(`${this.backendUrl}autorizacao/terceiro/deletar`, {
            idautorizacao: idcontrato,
          })
          .then((res) => {
            this.retornoDocOnline.retorno = res.data
            this.dialogDeletar = false;
            this.limparOperacao('D')
            this.carregando = false;
          })
          .catch(() => {
            this.carregando = false;
          });
    },

    calcularDiasRestantes(dataValidade) {
      const hoje = new Date();
      const validade = new Date(dataValidade);
      const diff = Math.ceil((validade - hoje) / (1000 * 60 * 60 * 24));
      return diff > 0 ? diff : 0;
    },

    calcularProgresso(dataValidade) {
      const totalDias = 180; // Ajuste conforme necessário
      const diasRestantes = this.calcularDiasRestantes(dataValidade);
      return (diasRestantes / totalDias) * 100;
    },

    definirCor(dataValidade) {
      const dias = this.calcularDiasRestantes(dataValidade);
      if (dias <= 5) return "red";
      if (dias <= 15) return "yellow";
      return "green";
    },

    nextPage() {
      if (this.page + 1 <= this.numberOfPages) this.page += 1
    },
    formerPage() {
      if (this.page - 1 >= 1) this.page -= 1
    },
    updateItemsPerPage(number) {
      this.itemsPerPage = number
    },
    closeDialogProfissional() {
      this.dialogProfissionais = false;
      this.novoAutorizado = {};
      this.clienteNome = null;
    },
    closeDialogPermissao() {
      this.dialogGerarPermissao = false;
      this.e1 = 1;
      this.listarPedidos(0);
      this.dadosGerarPermissao.dadosCliente.idclifor = null;
      this.dadosGerarPermissao.dadosCliente.nome = '';
      this.dadosGerarPermissao.dadosCliente.cpf = '';
      this.dadosGerarPermissao.dadosCliente.telefone = '';
      this.dadosGerarPermissao.dadosCliente.uf = '';
      this.dadosGerarPermissao.dadosCliente.cep = '';
      this.dadosGerarPermissao.dadosCliente.cidade = '';
      this.dadosGerarPermissao.dadosCliente.endereco = '';
      this.dadosGerarPermissao.dadosCliente.numero = '';
      this.dadosGerarPermissao.dadosCliente.bairro = '';

      this.dadosGerarPermissao.dadosTerceiro.idclifor = null;
      this.dadosGerarPermissao.dadosTerceiro.nome = null;
      this.dadosGerarPermissao.dadosTerceiro.idCadastroAut = '';
      this.dadosGerarPermissao.dadosTerceiro.telefone = '';
      this.dadosGerarPermissao.dadosTerceiro.cpf = '';
      this.dadosGerarPermissao.dadosTerceiro.tipoRelacionamento = '';
      this.dadosGerarPermissao.dadosTerceiro.tipoProfissional = '';
      this.dadosGerarPermissao.dadosTerceiro.dataValidade = `${new Date(new Date().setMonth(new Date().getMonth() + 3))
          .toISOString()
          .slice(0, 10)}`;

      this.listarAutorizacoes();

    },
    closeDialogGerarRecibo() {
      this.dialogGerarRecibo = false;
      this.dadosGerarRecibo.nomeClienteRecibo = null;
      this.dadosGerarRecibo.pedidoRecibo = null;
      this.step = 1;
    },
    closeDialogQrcode() {
      this.dialogQrcode = false;

      setTimeout(() => {
        this.labelSubtitulo = '';
        const canvas = this.$refs.qrcodeCanvas
        const context = canvas.getContext('2d')
        context.clearRect(0, 0, canvas.width, canvas.height)
      }, 500)
    },

    limparOperacao(tipo) {

      if (tipo === 'D') {
        this.dadosDeletar.idfilial = null
        this.dadosDeletar.filial = null
        this.dadosDeletar.idDoc = null
        this.dadosDeletar.clienteDoc = null
        this.dadosDeletar.profissionalDoc = null
        this.dadosDeletar.dtcadastro = null
        this.dadosDeletar.dtvalidade = null
      }

    },

    gerarSegundaVia() {
      this.dadosGerarRecibo.nomeTerceiroSelecionado = null;
      this.dadosGerarRecibo.terceiroSelecionado = null;
      setTimeout(() => {
        this.step = 1;
      }, 300);
    },

    limparCadastro() {
      this.dadosPendente.idautorizacao = null;
      this.dadosPendente.cliente = null;
      this.dadosPendente.autorizado = null;
      this.dadosPendente.dtcadastro = null;
      this.dadosPendente.dataValidade = '';
      this.dadosPendente.hashCliente = null;
      this.dadosPendente.hashProfissional = null;
      this.dadosPendente.statusAssinaturaCliente = null;
      this.dadosPendente.statusAssinaturaProfissional = null;
      this.dadosPendente.statusGeral = null;

    },

    // Função para capturar e formatar a data
    formatDate(segundosAdicionais = 0) {
      // Criar a data atual
      const now = new Date();

      // Adicionar os segundos extras
      now.setSeconds(now.getSeconds() + segundosAdicionais);

      // Nome dos meses em português
      const meses = [
        "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
        "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
      ];

      // Obter as partes da data
      const dia = now.getDate(); // Dia do mês
      const mes = meses[now.getMonth()]; // Nome do mês
      const ano = now.getFullYear(); // Ano
      const horas = now.getHours().toString().padStart(2, "0"); // Horas (2 dígitos)
      const minutos = now.getMinutes().toString().padStart(2, "0"); // Minutos (2 dígitos)
      const segundos = now.getSeconds().toString().padStart(2, "0"); // Segundos (2 dígitos)

      // Montar a string no formato desejado
      return `${dia} ${mes} ${ano}, ${horas}:${minutos}:${segundos}`;
    },
    copy(link, inputN) {
      var copyTextarea = this.$refs[inputN].$refs.input;
      copyTextarea.select();
      try {
        var successful = document.execCommand("copy");
        var msg = successful ? "sim!" : "não!";
        if (successful) {
          msg = `"${link}" foi copiado para sua área de transferência`;
        } else {
          msg =
              "Não foi possível copiar o texto, use o atalho Crtl+C.";
        }
        this.snackbar.color = 'primary';
        this.snackbar.text = msg;
        this.snackbar.status = true;
      } catch (err) {
        this.snackbar.color = 'red';
        this.snackbar.text =
            "Não foi possível copiar o texto, use o atalho Crtl+C.";
        this.snackbar.status = true;
      }
    },
    gerarQRCode(link, label) {
      this.carregandoQrcode = true;
      this.labelSubtitulo = label;
      this.dialogQrcode = true;
      // Gera o QR Code e o renderiza no canvas
      setTimeout(() => {
        QRCode.toCanvas(this.$refs.qrcodeCanvas, link, {width: 400}, (error) => {
          if (error) console.error(error)
        })
        this.carregandoQrcode = false;
      }, 1000)
    },
    converterBlobParaBase64(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result.split(',')[1]); // Remove o prefixo "data:application/pdf;base64,"
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    },

    async carregarImagemBase64(url) {
      // Fazendo a conversão para Base64
      const response = await fetch(url);
      const blob = await response.blob();
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    },

    async init() {
      this.busca.idfilial = this.usuario.idfilial;
      const json = localStorage.getItem("filtros_contratos");
      const filtro = JSON.parse(json);
      if (filtro) {
        this.busca = filtro;
      }
      await this.listaTipoProfissional();
      await this.listarAutorizacoes();
      await this.listaTipoRelacionamento();
    },
  },
  watch: {
    searchTerceiro: function (val) {
      this.carregarTerceiros(val);
    },
    searchProfissional: function (val) {
      this.carregarProfissional(val);
    },
    searchCliente: function (val) {
      this.carregarClientes(val);
    },


    "dadosGerarRecibo.dadosCliente.idclifor"(novoValor) {
      const clienteSelecionado = this.clientesLista.find(c => c.idcliente === novoValor);
      this.dadosGerarRecibo.dadosCliente.telefone = clienteSelecionado ? clienteSelecionado.endereco.telefoneComercial : "";
      this.dadosGerarRecibo.dadosCliente.endereco = clienteSelecionado ? clienteSelecionado.endereco.endereco : "";
      this.dadosGerarRecibo.dadosCliente.numero = clienteSelecionado ? clienteSelecionado.endereco.numero : "";
      this.dadosGerarRecibo.dadosCliente.bairro = clienteSelecionado ? clienteSelecionado.endereco.bairro : "";
      this.dadosGerarRecibo.dadosCliente.cidade = clienteSelecionado ? clienteSelecionado.endereco.cidade : "";
      this.dadosGerarRecibo.dadosCliente.uf = clienteSelecionado ? clienteSelecionado.endereco.uf : "";
      this.dadosGerarRecibo.dadosCliente.cpf = clienteSelecionado ? clienteSelecionado.cpfcnpj : "";
      this.dadosGerarRecibo.dadosCliente.nome = clienteSelecionado ? clienteSelecionado.nome : "";
    },
    "dadosGerarRecibo.dadosTerceiro.idclifor"(novoValor) {
      const profissionalSelecionado = this.profissionaisLista.find(c => c.idcliente === novoValor);
      this.dadosGerarRecibo.dadosTerceiro.telefone = profissionalSelecionado ? profissionalSelecionado.endereco.telefoneComercial : "";
      this.dadosGerarRecibo.dadosTerceiro.nome = profissionalSelecionado ? profissionalSelecionado.nome : "";
    },
    "dadosGerarRecibo.dadosCliente.telefone"(novoValor) {
      let numero = novoValor.replace(/\D/g, ''); // Remove tudo que não for número

      // Limita o número a no máximo 11 dígitos (para suportar telefones com 9 dígitos no Brasil)
      numero = numero.slice(0, 11);

      if (numero.length > 10) {
        this.dadosGerarRecibo.dadosCliente.telefone = numero.replace(/^(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
      } else {
        this.dadosGerarRecibo.dadosCliente.telefone = numero.replace(/^(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3');
      }
    },
    "dadosGerarPermissao.dadosCliente.telefone"(novoValor) {
      let numero = novoValor.replace(/\D/g, ''); // Remove tudo que não for número

      // Limita o número a no máximo 11 dígitos (para suportar telefones com 9 dígitos no Brasil)
      numero = numero.slice(0, 11);

      if (numero.length > 10) {
        this.dadosGerarPermissao.dadosCliente.telefone = numero.replace(/^(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
      } else {
        this.dadosGerarPermissao.dadosCliente.telefone = numero.replace(/^(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3');
      }
    },
    "dadosGerarPermissao.dadosTerceiro.telefone"(novoValor) {
      if (novoValor.length === 11) {
        let numero = novoValor.replace(/\D/g, ''); // Remove tudo que não for número

        // Limita o número a no máximo 11 dígitos (para suportar telefones com 9 dígitos no Brasil)
        numero = numero.slice(0, 11);

        if (numero.length > 10) {
          this.dadosGerarPermissao.dadosTerceiro.telefone = numero.replace(/^(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
        } else {
          this.dadosGerarPermissao.dadosTerceiro.telefone = numero.replace(/^(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3');
        }
      }
    },
    "dadosGerarRecibo.terceiroSelecionado"(novoValor) {
      let terceiro = this.terceirosAssinar.find(c => c.idclifor === novoValor);

      this.dadosGerarRecibo.dadosTerceiro.nome = terceiro ? terceiro.terceiro : "";
      this.dadosGerarRecibo.dadosTerceiro.tipoProfissional = terceiro ? terceiro.tipo : "";
      this.dadosGerarRecibo.dadosTerceiro.cpf = terceiro ? terceiro.cpf : "";
    },
    "dadosGerarPermissao.dadosCliente.idclifor"(novoValor) {
      const clienteSelecionado = this.clientesLista.find(c => c.idcliente === novoValor);
      this.dadosGerarPermissao.dadosCliente.telefone = clienteSelecionado ? clienteSelecionado.endereco.telefoneComercial : "";
      this.dadosGerarPermissao.dadosCliente.endereco = clienteSelecionado ? clienteSelecionado.endereco.endereco : "";
      this.dadosGerarPermissao.dadosCliente.numero = clienteSelecionado ? clienteSelecionado.endereco.numero : "";
      this.dadosGerarPermissao.dadosCliente.bairro = clienteSelecionado ? clienteSelecionado.endereco.bairro : "";
      this.dadosGerarPermissao.dadosCliente.cidade = clienteSelecionado ? clienteSelecionado.endereco.cidade : "";
      this.dadosGerarPermissao.dadosCliente.uf = clienteSelecionado ? clienteSelecionado.endereco.uf : "";
      this.dadosGerarPermissao.dadosCliente.cpf = clienteSelecionado ? clienteSelecionado.cpfcnpj : "";
      this.dadosGerarPermissao.dadosCliente.nome = clienteSelecionado ? clienteSelecionado.nome : "";
    },
    "dadosGerarPermissao.dadosTerceiro.idclifor"(novoValor) {
      const terceiroSelecionado = this.terceirosLista.find(c => c.idcliente === novoValor);
      this.dadosGerarPermissao.dadosTerceiro.nome = terceiroSelecionado ? terceiroSelecionado.nome : "";
      this.dadosGerarPermissao.dadosTerceiro.telefone = terceiroSelecionado ? terceiroSelecionado.endereco.telefoneComercial : "";
      this.dadosGerarPermissao.dadosTerceiro.cpf = terceiroSelecionado ? terceiroSelecionado.cpfcnpj : "";
    },
    "listaContratosPermissao.lista" (newVal) {
      // Garante que a página atual esteja dentro do limite
      if ((this.currentPage - 1) * this.itemsPerPage >= newVal.length) {
        this.currentPage = 1;
      }
    }
    // "dadosGerarPermissao.dadosTerceiro.dataValidade"(novoValor) {
    //
    //   const hoje = new Date();
    //   hoje.setHours(0, 0, 0, 0);
    //
    //
    //   const data = new Date(novoValor + "T00:00:00");
    //   data.setHours(0, 0, 0, 0);
    //
    //   if (data < hoje) {
    //     this.dataValida = false;
    //   }
    //
    //   if (data >= hoje) {
    //     this.dataValida = true; // válido
    //   }
    //
    //   if(novoValor === null){
    //     this.dataValida = false
    //   }
    //
    // }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.checkScrollPosition);
  },
  created() {
    this.init();
  },
  mounted() {
    window.addEventListener('scroll', this.checkScrollPosition);
    this.carregarClientes();
  },
};
</script>

<style scoped>
.overlay-fullwidth {
  display: block;
}

.v-card-profissional {
  background-color: #3D7AA8;
}

::v-deep .scroll-detalhes {
  box-shadow: none !important;
  scrollbar-width: thin; /* Largura da barra de rolagem */
  scrollbar-color: #f1f1f1 #023449; /* Cor da barra de rolagem e da trilha */
}

/* Estilizando a barra de rolagem para navegadores WebKit */
::v-deep .scroll-detalhes::-webkit-scrollbar {
  width: 8px; /* Largura da barra de rolagem */
}

::v-deep .scroll-detalhes::-webkit-scrollbar-track {
  background: #f1f1f1; /* Cor de fundo da trilha */
}

::v-deep .scroll-detalhes::-webkit-scrollbar-thumb {
  background-color: #f1f1f1; /* Cor da barra de rolagem */
  border-radius: 10px; /* Bordas arredondadas */
  border: 2px solid #023449; /* Espaço ao redor da barra de rolagem */
}

.chip-clip {
  cursor: pointer;
}


::v-deep .custom-chip .v-chip {
  background-color: #023449 !important;
  border-radius: 5px !important;
  color: white !important;
  height: 25px !important;
}

::v-deep .dialog-detalhes {
  box-shadow: none !important;
  scrollbar-width: thin; /* Largura da barra de rolagem */
  scrollbar-color: #f1f1f1 #023449; /* Cor da barra de rolagem e da trilha */
}

/* Estilizando a barra de rolagem para navegadores WebKit */
::v-deep .dialog-detalhes::-webkit-scrollbar {
  width: 8px; /* Largura da barra de rolagem */
}

::v-deep .dialog-detalhes::-webkit-scrollbar-track {
  background: #f1f1f1; /* Cor de fundo da trilha */
}

::v-deep .dialog-detalhes::-webkit-scrollbar-thumb {
  background-color: #f1f1f1; /* Cor da barra de rolagem */
  border-radius: 10px; /* Bordas arredondadas */
  border: 2px solid #023449; /* Espaço ao redor da barra de rolagem */
}

</style>